<script setup lang="ts">
import { defineProps } from "vue";

defineProps<{
  color: string;
}>();
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 1798.000000 1799.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,1799.000000) scale(0.100000,-0.100000)"
      stroke="none"
    >
      <path
        :fill="color"
        d="M8470 17969 c-2209 -131 -4266 -1055 -5830 -2619 -1403 -1403 -2293
-3202 -2554 -5160 -87 -651 -101 -1375 -40 -2030 183 -1975 1015 -3830 2367
-5282 1347 -1446 3127 -2408 5062 -2738 1876 -319 3799 -39 5500 800 2069
1022 3682 2824 4470 4995 744 2049 711 4341 -90 6360 -484 1219 -1196 2277
-2150 3195 -450 433 -948 819 -1495 1157 -1265 783 -2707 1236 -4214 1323
-203 11 -824 11 -1026 -1z m510 -633 l0 -603 -187 -7 c-597 -21 -1112 -90
-1644 -219 l-137 -33 -10 35 c-40 138 -303 1133 -300 1136 2 2 67 20 144 39
439 111 947 193 1419 230 265 21 278 22 513 24 l202 2 0 -604z m533 594 c460
-28 945 -93 1368 -185 163 -36 401 -94 407 -100 3 -2 -307 -1168 -311 -1171
-1 -1 -54 12 -117 27 -487 122 -1022 197 -1577 221 l-273 12 0 603 0 603 165
0 c91 0 243 -5 338 -10z m-2692 -893 c83 -313 149 -570 147 -573 -3 -2 -67
-22 -144 -45 -526 -153 -1040 -366 -1537 -636 -78 -42 -142 -72 -147 -67 -25
27 -599 1038 -593 1045 17 16 236 134 433 233 474 239 1000 446 1510 595 145
42 166 46 172 32 4 -9 75 -272 159 -584z m4675 553 c594 -173 1231 -435 1769
-729 94 -51 174 -96 178 -100 8 -8 -590 -1051 -602 -1051 -4 0 -70 34 -147 77
-477 262 -1050 496 -1601 653 -40 12 -73 25 -73 31 0 9 294 1115 305 1147 6
18 19 16 171 -28z m-6691 -1377 c164 -285 300 -521 301 -524 2 -3 -45 -35
-104 -70 -454 -269 -974 -669 -1365 -1048 l-98 -95 -424 424 c-234 234 -425
430 -425 436 0 16 205 211 402 385 293 258 629 515 957 733 188 125 432 276
447 276 6 0 145 -233 309 -517z m8812 446 c414 -249 888 -596 1263 -924 188
-164 420 -385 420 -399 0 -6 -191 -202 -424 -435 l-424 -424 -149 139 c-418
391 -830 706 -1286 984 -76 46 -136 86 -135 90 17 39 602 1040 609 1040 4 0
61 -32 126 -71z m-4642 -131 c0 -87 -1 -360 -3 -606 l-2 -449 -207 -6 c-425
-13 -859 -71 -1282 -173 -79 -19 -145 -33 -146 -32 -10 18 -310 1165 -305
1171 9 11 362 92 551 126 436 80 941 130 1274 127 l120 -1 0 -157z m575 141
c436 -33 891 -105 1298 -205 79 -20 112 -32 112 -43 0 -20 -301 -1144 -309
-1153 -3 -4 -40 2 -81 12 -129 34 -458 98 -635 124 -233 34 -471 56 -715 64
l-205 7 -3 609 -2 609 202 -7 c112 -3 264 -11 338 -17z m-2409 -831 c106 -397
153 -585 145 -589 -6 -3 -76 -25 -156 -49 -400 -117 -921 -337 -1274 -537 -43
-25 -82 -41 -86 -36 -13 13 -600 1032 -600 1040 0 18 475 262 715 368 172 76
422 174 603 236 175 60 461 148 482 149 12 0 51 -135 171 -582z m4035 537
c420 -124 854 -295 1244 -490 183 -91 387 -203 395 -215 4 -7 -573 -1019 -595
-1044 -5 -4 -48 14 -97 42 -374 210 -851 410 -1298 542 -94 27 -130 42 -129
53 4 43 309 1157 317 1157 6 0 79 -20 163 -45z m-5738 -1256 c161 -279 292
-511 292 -516 0 -5 -64 -49 -142 -98 -365 -226 -699 -482 -1033 -793 l-130
-121 -427 427 c-236 235 -428 429 -428 432 0 3 73 74 163 157 409 380 760 649
1227 940 127 79 167 100 176 90 6 -6 142 -240 302 -518z m7822 278 c369 -245
746 -548 1044 -837 l119 -116 -433 -426 -433 -427 -126 121 c-293 282 -712
601 -1071 818 -58 35 -106 64 -108 65 -2 2 561 980 594 1032 l14 23 118 -72
c64 -39 191 -120 282 -181z m-3840 23 c218 -16 367 -32 381 -41 10 -6 -3 -125
-65 -601 -43 -326 -79 -594 -80 -594 0 -1 -62 5 -136 14 -192 23 -870 22
-1055 0 -71 -9 -131 -15 -132 -14 -1 1 -38 270 -81 597 -70 530 -76 595 -62
600 15 6 299 35 415 42 122 8 702 6 815 -3z m-1206 -644 c42 -324 73 -592 69
-596 -4 -4 -46 -12 -93 -19 -317 -45 -720 -152 -1054 -278 -65 -25 -122 -41
-126 -36 -10 10 -462 1104 -458 1108 2 1 68 27 148 58 406 155 881 280 1305
346 66 10 123 15 126 12 3 -3 41 -271 83 -595z m2086 524 c244 -49 509 -121
755 -205 263 -89 381 -138 377 -156 -6 -23 -445 -1083 -453 -1093 -4 -5 -74
16 -156 47 -302 113 -631 202 -948 255 -124 21 -171 33 -173 44 -3 14 145
1153 152 1174 5 14 175 -11 446 -66z m-6896 -962 c-378 -394 -764 -898 -1033
-1350 l-64 -107 -47 27 c-692 399 -1000 579 -1000 586 0 14 139 240 265 431
289 437 646 884 1005 1258 l123 128 431 -430 430 -430 -110 -113z m12304 572
c280 -318 511 -619 747 -975 127 -191 275 -430 275 -444 0 -5 -887 -522 -1026
-598 -21 -12 -25 -8 -100 115 -278 457 -597 876 -974 1281 l-153 163 429 430
429 429 114 -118 c62 -65 179 -192 259 -283z m-8964 -531 c124 -301 226 -550
226 -555 0 -5 -21 -18 -48 -28 -274 -110 -687 -345 -986 -561 -59 -42 -111
-73 -116 -69 -6 7 -445 580 -686 895 l-43 56 117 85 c172 126 416 284 597 387
250 143 692 357 707 342 3 -3 108 -252 232 -552z m4857 505 c161 -71 479 -234
634 -325 230 -134 643 -416 652 -444 3 -10 -712 -947 -726 -953 -4 -1 -36 19
-72 46 -250 189 -669 433 -956 558 -62 27 -113 54 -113 59 -1 24 454 1105 465
1105 7 0 59 -21 116 -46z m-7629 -891 l427 -428 -121 -130 c-302 -324 -553
-649 -783 -1017 -53 -84 -102 -153 -109 -153 -6 0 -244 134 -529 299 l-517
298 22 37 c260 429 502 767 793 1106 95 112 377 415 384 415 4 0 198 -192 433
-427z m10811 69 c209 -239 427 -522 605 -789 110 -164 252 -394 252 -407 0 -9
-312 -192 -1000 -587 l-46 -27 -86 142 c-218 358 -528 759 -812 1054 l-110
113 430 430 429 430 115 -118 c63 -65 164 -173 223 -241z m-5233 94 c1067
-128 1967 -513 2785 -1192 164 -136 489 -461 624 -623 729 -876 1136 -1889
1212 -3016 14 -218 7 -648 -16 -855 -185 -1712 -1159 -3181 -2662 -4017 -1098
-610 -2418 -795 -3658 -511 -1006 229 -1951 776 -2643 1528 -813 883 -1282
1964 -1373 3159 -15 203 -6 727 15 920 123 1078 544 2041 1251 2857 126 145
422 437 560 553 827 690 1808 1103 2850 1201 61 6 128 12 150 14 111 10 778
-3 905 -18z m-4125 -538 c198 -259 361 -476 362 -482 1 -6 -59 -60 -134 -121
-175 -141 -536 -503 -678 -678 -60 -74 -115 -134 -122 -132 -7 2 -224 167
-483 365 l-470 361 19 27 c97 135 383 453 572 637 187 182 548 497 569 494 3
0 167 -212 365 -471z m7650 356 c351 -291 650 -592 932 -941 l83 -102 -471
-361 c-259 -199 -477 -364 -483 -366 -7 -3 -35 23 -62 58 -202 258 -481 540
-760 771 l-121 100 169 221 c94 121 259 337 367 478 108 141 198 257 201 257
3 1 68 -51 145 -115z m-11317 -820 c273 -158 503 -292 511 -299 11 -11 2 -35
-62 -152 -269 -495 -487 -1021 -637 -1537 -22 -77 -42 -141 -43 -143 -2 -1
-263 67 -581 152 -318 85 -579 155 -582 155 -11 0 1 50 51 220 154 512 333
962 572 1440 164 329 241 463 259 456 8 -3 239 -135 512 -292z m15082 149
c219 -398 421 -848 581 -1293 96 -267 217 -665 206 -676 -9 -10 -1151 -314
-1162 -310 -5 2 -21 43 -34 92 -133 491 -390 1116 -654 1594 -49 89 -71 137
-63 142 67 41 1033 597 1038 598 3 0 43 -66 88 -147z m-12490 -766 c250 -192
461 -355 469 -362 11 -11 -1 -33 -73 -133 -185 -258 -362 -561 -493 -843 -40
-87 -73 -163 -73 -169 0 -5 -4 -10 -9 -10 -14 0 -1095 450 -1105 460 -18 18
178 432 334 705 164 285 462 721 484 708 6 -4 216 -164 466 -356z m10014 8
c51 -77 131 -203 177 -280 133 -223 405 -775 388 -788 -6 -5 -1082 -449 -1099
-454 -11 -3 -24 16 -44 64 -55 129 -215 438 -299 580 -77 129 -219 342 -299
451 -28 37 -30 44 -17 56 8 8 223 174 478 370 l465 356 79 -108 c43 -59 120
-170 171 -247z m-11344 -120 c190 -109 347 -200 349 -202 3 -2 -12 -34 -32
-71 -83 -148 -232 -453 -301 -615 -106 -248 -243 -636 -282 -800 -4 -16 -12
-31 -19 -33 -14 -6 -1145 294 -1159 307 -17 15 149 531 264 820 116 289 279
633 422 891 l59 106 177 -102 c97 -56 332 -192 522 -301z m12695 318 c133
-228 370 -739 485 -1048 89 -239 229 -681 218 -689 -3 -3 -1148 -308 -1162
-310 -4 0 -32 78 -61 174 -125 413 -302 838 -501 1203 -53 97 -73 142 -66 149
13 13 1024 597 1034 598 4 0 28 -35 53 -77z m-12110 -1533 c297 -123 542 -225
545 -227 2 -2 -4 -25 -14 -51 -138 -356 -252 -774 -302 -1102 -10 -63 -20
-118 -23 -122 -5 -6 -1044 125 -1167 147 l-31 5 18 123 c57 371 154 758 283
1130 96 274 119 329 136 324 8 -2 258 -104 555 -227z m11383 139 c135 -346
244 -717 316 -1079 38 -189 72 -408 65 -413 -6 -5 -1191 -159 -1193 -155 -1 2
-15 77 -30 168 -59 350 -163 731 -280 1020 -19 47 -33 87 -31 88 9 10 1101
460 1110 458 5 -2 25 -40 43 -87z m-14057 -210 c310 -82 569 -152 575 -154 8
-2 1 -48 -22 -142 -130 -534 -198 -1042 -220 -1640 l-7 -183 -605 0 -605 0 6
268 c14 578 89 1159 228 1757 51 216 59 245 75 245 6 0 266 -68 575 -151z
m16747 24 c164 -673 262 -1425 262 -2010 l0 -133 -604 0 -603 0 -7 53 c-3 28
-6 100 -6 159 0 420 -90 1094 -214 1603 -19 77 -33 141 -31 143 5 5 1138 310
1156 311 13 1 23 -27 47 -126z m-15535 -349 c320 -86 583 -157 585 -158 1 -2
-13 -68 -32 -147 -101 -421 -160 -856 -173 -1281 l-6 -208 -610 0 -610 0 7
198 c18 517 77 990 182 1457 58 260 67 295 71 295 3 0 266 -70 586 -156z
m14335 -34 c127 -549 182 -974 207 -1602 l7 -158 -610 0 -609 0 -7 188 c-16
442 -69 852 -163 1252 -20 85 -38 164 -40 175 -4 18 40 32 579 176 321 86 586
154 590 150 3 -3 24 -85 46 -181z m-13235 -1045 c307 -40 560 -75 562 -76 1
-2 -4 -65 -13 -139 -23 -192 -22 -861 0 -1045 9 -71 13 -133 10 -136 -4 -3
-272 -41 -596 -83 -427 -56 -591 -74 -596 -66 -4 7 -16 98 -26 203 -27 269
-27 950 -1 1207 24 231 21 221 66 214 20 -3 287 -38 594 -79z m12141 43 c39
-268 56 -821 37 -1143 -13 -214 -36 -444 -45 -453 -5 -5 -1187 146 -1194 153
-1 1 5 72 15 156 24 218 24 790 0 1008 -10 84 -16 155 -14 158 2 2 269 39 593
82 324 43 592 79 595 80 4 1 9 -18 13 -41z m-14124 -855 c0 -111 21 -479 36
-643 34 -367 98 -754 179 -1088 29 -117 39 -175 31 -178 -10 -4 -981 -264
-1108 -297 l-57 -15 -45 187 c-152 631 -246 1360 -246 1924 l0 167 605 0 605
0 0 -57z m1263 -150 c13 -430 76 -894 177 -1305 16 -67 28 -123 26 -125 -4 -5
-1154 -313 -1165 -313 -4 0 -24 69 -44 153 -127 525 -193 1025 -213 1600 l-7
197 610 0 610 0 6 -207z m14159 32 c-8 -427 -64 -931 -152 -1360 -40 -195 -95
-407 -106 -412 -13 -5 -1144 295 -1157 307 -5 4 5 63 22 131 106 439 180 1021
181 1422 l0 87 608 -2 607 -3 -3 -170z m1258 36 c0 -460 -73 -1128 -180 -1646
-30 -145 -110 -487 -115 -493 -3 -3 -1168 308 -1173 313 -2 1 11 56 27 121
121 479 203 1054 216 1519 3 99 8 213 11 253 l6 72 604 0 604 0 0 -139z
m-14116 -605 c32 -275 136 -688 258 -1024 38 -106 68 -195 66 -197 -7 -7
-1095 -455 -1105 -455 -11 0 -55 109 -133 330 -62 175 -149 481 -195 685 -34
149 -107 556 -101 562 4 5 1191 160 1197 157 3 -2 9 -28 13 -58z m10958 -21
c312 -41 573 -75 578 -75 16 0 12 -36 -20 -227 -58 -335 -132 -631 -240 -953
-93 -277 -145 -406 -162 -402 -7 2 -259 105 -561 230 -439 182 -546 230 -541
242 4 8 31 79 60 157 108 285 199 628 251 941 24 146 29 162 47 162 11 0 275
-34 588 -75z m-11992 -1080 c127 -420 296 -828 495 -1197 48 -88 85 -161 83
-163 -9 -8 -1033 -597 -1041 -598 -21 -4 -252 441 -375 719 -92 210 -186 455
-257 669 -75 226 -129 414 -121 422 8 8 1139 312 1154 310 9 -1 33 -65 62
-162z m13042 9 c321 -86 584 -157 586 -159 6 -5 -85 -303 -144 -477 -113 -330
-235 -621 -394 -939 -94 -188 -208 -399 -216 -399 -7 0 -1028 591 -1039 601
-6 6 5 34 28 77 137 246 300 596 397 851 53 140 158 460 180 549 8 28 15 52
17 52 1 0 265 -70 585 -156z m-14277 -261 c147 -525 402 -1145 660 -1605 36
-65 65 -121 65 -125 0 -4 -123 -78 -273 -164 -149 -86 -385 -222 -523 -302
l-252 -145 -68 122 c-242 430 -488 989 -654 1483 -75 225 -150 476 -150 503 0
13 106 45 578 172 317 86 580 156 583 157 4 1 19 -43 34 -96z m2655 7 c129
-297 344 -673 537 -937 81 -112 84 -117 66 -134 -49 -48 -936 -718 -943 -714
-32 20 -320 450 -449 670 -84 142 -285 541 -339 671 l-30 71 557 231 c306 126
559 227 562 224 4 -4 21 -41 39 -82z m10173 -147 c301 -124 547 -230 547 -235
0 -4 -38 -92 -85 -195 -99 -217 -248 -495 -378 -703 -157 -252 -344 -513 -362
-506 -7 2 -224 167 -483 366 l-470 361 86 119 c183 251 383 595 511 878 36 78
69 142 75 142 6 0 257 -102 559 -227z m2665 75 c312 -83 571 -154 576 -159 10
-9 -65 -271 -156 -539 -166 -489 -378 -969 -629 -1428 -44 -81 -82 -148 -84
-150 -2 -2 -1028 586 -1053 603 -1 1 28 55 64 121 266 480 514 1077 654 1576
36 125 37 128 51 128 6 0 265 -68 577 -152z m-12078 -1155 c145 -176 516 -547
688 -688 73 -60 131 -112 130 -116 -6 -18 -724 -948 -731 -949 -27 -1 -414
338 -617 540 -235 236 -551 603 -533 620 7 7 947 729 949 730 0 0 52 -62 114
-137z m8643 -236 c257 -197 467 -362 467 -367 0 -10 -106 -142 -224 -280 -122
-142 -403 -427 -556 -564 -147 -133 -357 -306 -370 -306 -5 0 -173 214 -374
476 l-365 476 108 88 c280 228 629 584 806 821 11 15 25 24 30 21 6 -3 220
-167 478 -365z m-10159 215 c228 -375 547 -793 844 -1103 l101 -105 -430 -430
-430 -429 -111 115 c-360 374 -726 850 -999 1299 -49 79 -87 146 -86 148 7 6
1042 603 1047 603 3 0 32 -44 64 -98z m11686 -216 c272 -158 496 -290 498
-295 4 -12 -117 -210 -252 -411 -250 -373 -524 -714 -852 -1058 l-89 -93 -429
429 -429 430 133 143 c306 331 563 666 781 1018 l92 150 26 -14 c14 -7 249
-142 521 -299z m-12754 -443 c283 -467 602 -882 1031 -1341 l92 -98 -430 -430
-430 -429 -67 72 c-320 342 -460 503 -648 744 -200 256 -426 584 -597 865
l-86 142 522 301 c287 166 525 301 528 301 4 0 42 -57 85 -127z m13834 -181
c272 -157 499 -289 504 -293 19 -17 -330 -557 -554 -855 -241 -321 -473 -594
-707 -834 l-132 -135 -425 425 c-235 234 -426 429 -426 434 0 5 51 61 113 125
343 352 715 835 993 1288 36 60 73 118 80 131 13 19 18 21 37 11 12 -7 245
-140 517 -297z m-10305 -27 c269 -198 596 -389 905 -530 79 -36 146 -67 148
-70 4 -4 -446 -1096 -457 -1108 -10 -10 -233 90 -446 199 -289 147 -625 355
-873 538 l-103 76 98 128 c54 70 219 285 368 479 148 193 274 349 280 345 5
-3 42 -29 80 -57z m6615 -420 c194 -252 354 -464 356 -470 9 -22 -386 -293
-661 -454 -224 -131 -736 -383 -751 -369 -3 4 -403 964 -444 1069 l-18 46 91
38 c294 124 768 401 1007 588 34 27 48 32 56 24 7 -7 170 -219 364 -472z
m-8011 -38 c331 -318 788 -667 1143 -873 37 -21 68 -43 68 -47 0 -9 -569 -999
-593 -1031 -12 -17 -22 -13 -133 54 -467 285 -893 611 -1297 993 l-139 130
429 429 c235 235 430 428 432 428 2 0 43 -37 90 -83z m9474 -345 l429 -429
-148 -137 c-260 -244 -514 -453 -791 -654 -251 -183 -618 -412 -632 -396 -7 8
-564 973 -590 1021 -10 20 -5 25 77 74 363 218 753 514 1077 817 77 72 142
131 145 131 3 1 198 -192 433 -427z m-6818 126 c290 -111 669 -210 1010 -263
55 -9 101 -17 102 -19 5 -5 -153 -1185 -160 -1192 -17 -18 -558 89 -840 166
-244 67 -737 238 -737 257 0 5 449 1093 457 1106 3 5 12 5 22 2 9 -4 75 -30
146 -57z m3979 -370 c99 -238 203 -490 232 -560 l53 -127 -107 -42 c-264 -104
-646 -220 -927 -282 -228 -51 -555 -105 -555 -93 0 4 -34 263 -75 576 -41 313
-75 580 -75 594 0 21 6 25 43 31 260 39 579 112 807 184 135 42 376 128 400
142 8 4 17 9 20 9 3 0 86 -195 184 -432z m-2642 65 c197 -20 734 -23 909 -5
64 7 143 15 176 18 l59 6 78 -596 c43 -329 76 -599 74 -601 -7 -7 -300 -35
-478 -45 -321 -18 -655 -9 -1000 26 -85 9 -156 17 -157 18 -2 2 143 1111 152
1164 3 17 10 32 15 32 5 0 83 -7 172 -17z m-4800 -439 c418 -389 870 -730
1316 -993 39 -24 72 -48 72 -54 0 -11 -576 -1015 -594 -1034 -25 -28 -615 360
-996 656 -238 184 -394 318 -653 559 l-178 166 428 428 c235 235 431 427 435
426 4 -2 80 -71 170 -154z m11168 -270 l425 -425 -130 -127 c-287 -279 -642
-574 -990 -822 -277 -197 -692 -458 -705 -443 -12 13 -600 1034 -600 1042 0 3
46 33 103 66 150 87 469 303 647 437 262 196 599 486 760 652 24 25 49 46 55
46 5 0 201 -192 435 -426z m-8745 105 c343 -169 759 -331 1098 -424 32 -10 57
-22 57 -30 0 -7 -69 -271 -154 -586 -137 -509 -156 -574 -172 -571 -11 2 -102
28 -204 58 -232 69 -539 181 -774 281 -296 126 -816 390 -816 414 0 8 500 881
582 1016 l19 32 62 -35 c34 -20 170 -89 302 -155z m6386 -343 c224 -388 297
-521 287 -528 -38 -25 -261 -145 -386 -207 -426 -213 -832 -370 -1347 -520
-38 -11 -70 -19 -72 -18 -5 5 -314 1169 -311 1171 2 2 75 24 163 50 411 122
932 341 1270 535 39 22 76 39 83 38 8 -1 149 -236 313 -521z m-4991 -157 c401
-93 815 -147 1268 -164 l172 -7 0 -606 0 -605 -237 6 c-471 12 -948 72 -1438
182 -270 61 -277 63 -271 83 15 51 306 1143 306 1147 0 9 25 5 200 -36z m3278
-542 c85 -318 152 -580 149 -583 -10 -10 -230 -63 -427 -103 -446 -91 -845
-137 -1277 -148 l-243 -6 0 606 0 607 48 0 c205 1 620 34 877 71 146 20 543
98 630 123 92 26 70 76 243 -567z m-5563 88 c481 -268 1057 -508 1570 -656 83
-23 151 -44 153 -45 3 -2 -308 -1167 -313 -1172 -4 -4 -188 49 -395 115 -402
127 -853 310 -1233 499 -192 96 -487 257 -487 266 0 4 118 212 261 460 342
592 339 588 342 588 2 0 48 -25 102 -55z m7898 -465 c164 -286 299 -523 299
-527 1 -10 -57 -44 -272 -159 -401 -214 -879 -419 -1335 -572 -247 -83 -497
-154 -506 -145 -5 6 -306 1117 -313 1156 0 5 60 26 134 48 551 162 1178 424
1615 677 39 23 72 41 75 41 3 0 139 -233 303 -519z m-5893 -305 c497 -114 995
-178 1488 -192 l232 -6 0 -610 0 -610 -217 7 c-653 20 -1250 99 -1852 244
-106 25 -195 52 -198 58 -3 9 281 1091 302 1153 3 8 13 11 28 7 12 -3 110 -26
217 -51z m3879 -522 c85 -318 155 -582 155 -587 2 -17 -417 -114 -734 -170
-443 -78 -1049 -135 -1442 -136 l-98 0 0 608 0 609 238 6 c537 15 1170 103
1627 226 39 11 77 20 85 20 12 1 49 -126 169 -576z"
      />
      <path
        :fill="color"
        d="M7982 17619 c-166 -21 -306 -39 -310 -41 -4 -2 -5 -17 -2 -33 l5 -31
135 17 c74 9 136 15 138 14 3 -3 32 -228 29 -231 -1 -2 -59 -10 -127 -18 -201
-26 -191 -23 -184 -54 4 -15 8 -29 10 -31 2 -2 71 4 154 14 83 10 152 16 155
14 2 -3 10 -52 18 -111 l13 -106 -30 -6 c-17 -3 -77 -11 -134 -17 l-103 -12 7
-31 c3 -17 7 -32 9 -34 1 -1 130 14 286 33 156 19 287 35 292 35 9 0 9 41 -1
57 -5 8 -34 8 -117 -3 -61 -7 -117 -13 -125 -14 -13 0 -18 22 -28 107 -6 59
-9 110 -4 114 4 3 57 12 117 18 188 20 185 20 185 52 0 15 -3 30 -7 32 -5 3
-75 -4 -157 -15 -82 -10 -150 -17 -152 -15 -5 5 -35 230 -31 232 1 1 47 8 102
14 175 20 175 20 175 44 0 12 -4 27 -8 33 -5 7 -103 -2 -310 -27z"
      />
      <path
        :fill="color"
        d="M10213 17586 c-19 -24 -28 -66 -49 -234 -7 -52 -7 -52 -38 -47 -84
13 -249 35 -267 35 -17 0 -20 -5 -17 -32 l3 -33 150 -22 c83 -12 150 -22 151
-22 0 -1 -1 -13 -4 -29 -3 -23 -18 -35 -105 -80 -126 -65 -143 -79 -152 -119
-6 -28 -3 -33 17 -38 35 -7 454 -65 476 -65 13 0 21 9 25 28 3 15 3 29 1 31
-2 3 -90 17 -195 32 -105 15 -193 29 -195 32 -3 3 40 28 96 56 95 49 100 53
100 84 0 61 2 62 165 38 81 -11 151 -18 156 -15 5 3 9 18 9 33 l0 28 -152 21
c-83 12 -153 24 -155 26 -7 7 28 230 38 240 5 6 30 6 64 -1 l55 -10 0 26 c0
42 -11 49 -86 56 -68 7 -72 6 -91 -19z"
      />
      <path
        :fill="color"
        d="M5999 17141 c-78 -58 -159 -139 -197 -198 -17 -27 -34 -43 -47 -43
-11 0 -65 12 -120 26 -55 14 -109 27 -121 30 -15 4 -23 -1 -33 -22 -7 -15 -8
-31 -3 -36 5 -5 62 -22 127 -38 65 -17 120 -32 122 -34 2 -2 -10 -44 -27 -94
-38 -115 -38 -122 3 -122 31 0 32 2 59 83 53 166 160 311 299 402 38 26 69 49
69 52 0 8 -44 42 -55 43 -5 0 -40 -22 -76 -49z"
      />
      <path
        :fill="color"
        d="M6068 16979 c-108 -92 -208 -243 -247 -373 -12 -37 -21 -70 -21 -72
0 -2 15 -4 34 -4 33 0 35 2 50 54 16 54 16 54 105 100 49 25 92 46 94 46 3 0
-10 -25 -28 -56 -19 -31 -37 -69 -40 -84 -3 -16 -12 -33 -18 -38 -7 -5 -83
-37 -169 -71 -87 -35 -158 -67 -158 -71 0 -5 4 -20 10 -34 l9 -25 135 55 c75
30 141 54 148 54 7 0 26 -13 43 -29 l30 -30 29 25 28 25 -22 24 -22 24 33 14
c19 8 83 34 142 58 103 41 108 45 102 69 -4 14 -9 28 -13 32 -4 4 -56 -14
-116 -38 -59 -25 -110 -43 -112 -41 -9 8 47 122 77 160 29 36 30 39 15 62 -9
14 -19 25 -21 25 -3 0 -51 -23 -106 -51 l-101 -50 18 30 c22 38 115 136 169
180 l40 32 -25 19 c-14 11 -29 19 -35 19 -5 0 -31 -18 -57 -40z"
      />
      <path
        :fill="color"
        d="M12103 17120 c-13 -5 -23 -12 -23 -15 0 -12 83 -118 138 -177 l58
-61 32 17 33 17 -72 77 c-40 42 -83 94 -97 115 -26 39 -33 41 -69 27z"
      />
      <path
        :fill="color"
        d="M12011 16900 c-11 -34 -31 -22 162 -102 58 -24 97 -46 97 -55 0 -8
-7 -27 -15 -43 l-15 -29 -48 20 c-95 42 -92 41 -102 13 l-10 -26 -51 56 -51
56 -28 -17 -28 -16 50 -61 c35 -41 46 -61 37 -64 -8 -3 -37 -13 -66 -24 -51
-19 -51 -19 -40 -49 8 -20 16 -27 27 -23 61 25 116 42 122 36 3 -4 8 -15 10
-25 2 -14 -10 -23 -51 -40 -60 -24 -67 -33 -47 -60 13 -17 16 -16 61 3 25 11
49 20 51 20 2 0 4 -20 4 -44 0 -41 2 -44 29 -48 26 -4 30 -1 34 26 7 49 -9
149 -32 201 -12 26 -19 50 -17 52 5 6 296 -118 296 -126 0 -4 -21 -14 -48 -23
-69 -25 -142 -77 -157 -112 -8 -17 -11 -34 -7 -37 17 -17 226 -99 233 -92 4 4
10 17 13 29 5 18 -4 24 -74 53 -44 19 -80 37 -80 41 0 11 43 38 73 45 21 6 28
0 52 -40 24 -42 30 -46 53 -40 15 4 28 8 30 10 2 2 -8 24 -23 50 -15 25 -25
48 -23 51 3 2 37 5 76 7 73 2 76 4 65 46 -6 22 -9 23 -75 19 l-69 -4 6 26 c5
25 1 29 -60 54 -36 16 -65 29 -65 31 0 12 32 75 38 75 5 0 67 -25 138 -55 120
-51 130 -54 142 -38 7 10 11 24 10 32 -2 7 -58 37 -125 65 -67 28 -124 54
-127 57 -3 3 13 16 37 30 35 20 56 24 127 24 47 0 106 -4 131 -8 l45 -9 -4 35
c-4 35 -5 35 -69 47 -128 24 -253 -1 -323 -65 l-25 -23 -139 59 c-76 32 -140
59 -141 59 -2 0 -8 -14 -14 -30z"
      />
      <path
        :fill="color"
        d="M3963 16071 c-29 -24 -29 -26 7 -71 17 -21 30 -42 30 -47 0 -5 -20
-24 -45 -42 -25 -18 -45 -36 -45 -41 0 -4 8 -17 18 -29 l17 -21 52 40 c52 40
52 40 64 19 10 -20 7 -26 -26 -54 -28 -23 -36 -36 -30 -46 25 -40 160 -209
167 -209 5 0 25 12 45 27 35 27 36 27 50 8 13 -18 12 -22 -11 -42 -14 -11 -35
-28 -47 -37 -21 -14 -21 -16 -5 -41 l17 -26 50 37 50 37 15 -22 c18 -26 36
-27 57 -3 15 17 15 20 0 42 -18 25 -17 26 54 78 25 18 25 19 8 45 l-17 26 -45
-34 c-52 -40 -56 -41 -74 -19 -14 17 -6 27 54 69 17 12 13 21 -68 129 -53 70
-92 113 -99 109 -6 -4 -25 -17 -42 -30 -30 -22 -31 -23 -48 -4 -16 18 -15 20
34 56 27 20 50 40 50 43 0 4 -8 17 -18 29 l-17 22 -52 -39 -51 -40 -37 50
c-20 28 -37 50 -38 50 -1 -1 -12 -9 -24 -19z m257 -231 c8 -15 1 -24 -44 -58
-51 -39 -55 -40 -70 -23 -9 10 -16 20 -16 23 0 12 103 88 111 82 5 -3 13 -13
19 -24z m76 -108 c-2 -1 -27 -21 -56 -42 -53 -39 -53 -40 -68 -19 -16 23 -16
23 48 72 l45 35 17 -21 c9 -12 15 -23 14 -25z"
      />
      <path
        :fill="color"
        d="M3760 15909 c-42 -17 -161 -112 -176 -141 -19 -36 -18 -54 7 -105 15
-31 27 -43 42 -43 44 0 49 13 28 61 -25 54 -19 66 61 122 86 61 93 53 85 -91
-4 -64 -12 -146 -17 -181 -9 -53 -8 -67 5 -87 8 -13 20 -24 25 -24 11 0 219
152 219 160 0 3 -8 15 -19 28 l-19 23 -67 -50 c-37 -28 -69 -49 -71 -47 -2 2
0 47 6 100 21 187 11 249 -44 274 -30 14 -32 14 -65 1z"
      />
      <path
        :fill="color"
        d="M4061 15541 l3 -66 -107 -80 c-58 -44 -106 -82 -106 -85 0 -3 8 -15
19 -28 l19 -24 83 65 c46 35 88 67 95 70 7 5 17 -10 28 -43 l17 -50 29 16 c20
10 28 21 25 32 -20 69 -29 116 -35 177 -6 69 -6 69 -39 76 l-33 7 2 -67z"
      />
      <path
        :fill="color"
        d="M14058 16027 c-16 -23 -15 -24 44 -71 l60 -48 -38 -42 c-97 -104
-129 -136 -135 -136 -3 0 -26 16 -50 35 l-44 34 -23 -22 -24 -22 48 -41 47
-42 -98 -101 c-84 -87 -97 -104 -84 -115 8 -7 106 -84 218 -171 l204 -159 18
23 c11 13 19 26 19 30 -1 3 -30 28 -65 56 -36 27 -65 52 -65 55 0 3 33 39 74
79 51 51 78 71 87 65 8 -4 44 -31 80 -60 l66 -53 21 28 20 28 -69 52 c-38 29
-69 56 -69 60 0 9 164 171 174 171 4 0 35 -21 68 -47 l60 -47 19 24 c10 14 18
27 18 30 0 8 -540 425 -553 427 -6 2 -18 -8 -28 -20z m259 -238 c51 -40 93
-74 93 -78 0 -10 -164 -171 -175 -171 -5 0 -41 25 -80 56 -38 31 -79 62 -89
70 -18 12 -14 19 65 103 46 49 86 90 88 90 3 1 46 -31 98 -70z m-217 -234 c41
-32 77 -60 79 -62 6 -5 -74 -87 -121 -125 l-38 -29 -86 67 -86 67 78 78 c47
47 82 75 88 70 6 -4 45 -34 86 -66z"
      />
      <path
        :fill="color"
        d="M8151 16450 c-39 -9 -59 -27 -63 -55 -2 -11 3 -75 11 -143 8 -67 12
-124 10 -126 -2 -2 -71 -13 -154 -23 l-150 -19 3 -29 c2 -17 5 -32 7 -34 3 -2
62 4 133 13 177 22 182 22 182 -9 0 -19 -25 -50 -100 -121 -93 -90 -100 -99
-100 -135 0 -22 3 -39 8 -39 4 0 115 14 247 30 132 16 246 30 253 30 7 0 12
14 12 35 0 42 18 41 -215 11 -99 -13 -182 -22 -184 -20 -7 6 29 43 94 97 59
49 60 51 60 101 l0 51 55 7 c30 3 99 12 153 18 89 11 97 14 97 34 0 46 -6 47
-165 27 -83 -11 -152 -18 -154 -15 -7 7 -32 227 -27 240 3 7 32 15 65 19 l61
7 -15 29 c-13 25 -21 29 -53 28 -20 -1 -52 -5 -71 -9z"
      />
      <path
        :fill="color"
        d="M9736 16466 l-28 -22 38 -34 c42 -36 156 -112 198 -131 22 -10 29 -9
46 6 11 10 20 21 20 25 0 4 -41 34 -92 66 -50 32 -106 70 -123 85 l-31 28 -28
-23z"
      />
      <path
        :fill="color"
        d="M10286 16389 c-124 -20 -217 -70 -251 -133 -23 -42 -18 -42 -190 -16
-71 11 -133 20 -137 20 -5 0 -8 -15 -8 -33 l0 -33 143 -20 142 -19 3 -30 c4
-53 -7 -59 -87 -49 l-70 10 -6 -27 -6 -27 -60 41 -59 41 -26 -26 -26 -25 58
-39 c32 -22 59 -44 61 -49 2 -6 -13 -19 -32 -29 -55 -30 -69 -50 -53 -75 17
-28 21 -27 75 14 52 40 68 43 83 16 8 -16 5 -23 -23 -40 -18 -11 -42 -29 -52
-41 -17 -19 -17 -21 0 -40 17 -19 18 -19 61 12 24 17 47 29 50 25 4 -3 9 -21
13 -39 4 -18 10 -32 14 -30 4 1 19 2 33 2 25 0 26 2 20 38 -10 54 -58 152 -96
195 -17 20 -30 37 -27 37 11 0 293 -41 315 -46 21 -4 19 -7 -24 -37 -63 -42
-121 -113 -129 -157 l-6 -36 127 -17 c69 -10 128 -16 129 -15 1 2 5 15 8 29 8
30 3 32 -110 45 -35 3 -63 11 -63 16 0 6 17 26 37 44 l37 34 41 -40 c46 -45
51 -47 77 -23 18 16 17 18 -19 55 -44 45 -42 48 47 75 30 9 56 18 58 19 1 1
-5 15 -15 31 l-17 31 -50 -18 c-28 -10 -59 -21 -69 -25 -16 -7 -18 -4 -15 21
3 29 3 29 -70 38 l-73 9 7 41 c3 23 8 43 10 45 2 2 68 -5 146 -16 150 -21 158
-20 158 23 0 20 -10 22 -132 39 -73 10 -137 21 -141 25 -12 10 43 61 90 82 24
10 82 24 130 30 49 6 89 12 91 14 2 1 -4 16 -13 33 -17 33 -24 35 -109 20z"
      />
      <path
        :fill="color"
        d="M6235 15945 c-154 -63 -284 -116 -288 -117 -4 -2 -3 -17 3 -35 l11
-31 121 49 c67 27 127 49 134 49 11 0 101 -207 93 -214 -2 -1 -68 -29 -147
-61 -129 -53 -142 -60 -136 -79 3 -12 10 -25 15 -30 5 -5 66 15 149 49 77 31
144 55 147 51 8 -7 83 -186 83 -197 0 -4 -54 -29 -120 -55 -126 -50 -128 -52
-101 -101 4 -7 93 24 275 98 148 60 272 111 274 114 3 2 -1 18 -7 34 l-13 29
-119 -49 c-106 -42 -121 -46 -126 -31 -4 9 -21 53 -40 97 -18 44 -33 84 -33
90 0 5 51 30 113 54 195 77 178 67 165 99 -7 15 -13 28 -14 30 -1 2 -64 -22
-140 -52 -76 -31 -143 -56 -149 -56 -8 0 -99 211 -92 215 1 1 56 23 122 50 66
26 124 51 128 55 8 7 -12 60 -22 59 -3 0 -132 -52 -286 -114z"
      />
      <path
        :fill="color"
        d="M11602 15991 c-10 -28 -10 -29 59 -56 38 -15 69 -29 69 -32 0 -18
-114 -213 -125 -213 -7 0 -34 9 -60 21 -25 11 -48 19 -49 17 -1 -1 -7 -15 -13
-30 -11 -25 -10 -27 40 -48 29 -12 54 -24 56 -26 1 -1 -27 -58 -64 -124 -37
-67 -63 -126 -58 -130 9 -10 480 -210 492 -210 6 0 31 43 31 54 0 2 -36 19
-80 37 -45 18 -79 38 -78 43 7 27 104 176 114 176 6 0 46 -16 90 -35 72 -31
80 -33 92 -18 25 34 14 47 -64 78 -42 17 -78 34 -81 38 -3 5 93 176 122 215 1
1 34 -11 73 -28 39 -16 73 -30 75 -30 3 0 10 14 16 30 9 28 8 31 -22 44 -18 7
-161 68 -318 134 -158 67 -291 122 -297 122 -5 0 -15 -13 -20 -29z m318 -166
c58 -25 104 -49 103 -54 -1 -5 -30 -54 -64 -109 l-61 -100 -105 44 c-58 24
-107 44 -109 44 -10 0 112 220 121 220 6 0 57 -20 115 -45z m-162 -276 c53
-23 98 -43 100 -44 5 -5 -109 -185 -117 -185 -11 0 -175 71 -185 80 -9 9 83
190 97 190 4 0 52 -19 105 -41z"
      />
      <path
        :fill="color"
        d="M4731 15144 c-61 -66 -109 -147 -147 -242 l-27 -70 -64 -7 c-35 -4
-99 -5 -141 -3 l-77 3 -3 -39 -3 -39 135 5 135 5 -6 -115 -6 -115 24 6 c13 4
30 7 37 7 8 0 12 20 12 65 0 180 73 367 197 504 l52 58 -34 16 -34 16 -50 -55z"
      />
      <path
        :fill="color"
        d="M4839 15008 c-43 -59 -115 -211 -134 -283 -9 -33 -19 -100 -22 -148
l-6 -88 29 7 c43 10 44 11 44 69 l0 53 82 73 c45 41 78 65 74 54 -10 -27 -35
-145 -36 -170 -1 -14 -46 -54 -145 -129 l-144 -108 17 -24 c9 -13 21 -24 25
-24 4 0 61 40 125 89 l117 88 42 -20 42 -20 20 24 c26 31 26 37 -4 51 -14 6
-25 14 -25 17 1 3 55 46 120 95 66 49 120 95 120 101 0 7 -9 20 -19 29 -19 17
-23 15 -113 -53 -90 -68 -93 -69 -96 -45 -4 32 14 117 34 160 17 36 14 48 -16
64 -17 9 -33 -1 -105 -65 -47 -42 -85 -73 -85 -70 0 20 60 141 99 200 25 39
47 73 49 77 2 4 -10 14 -27 23 l-31 15 -31 -42z"
      />
      <path
        :fill="color"
        d="M13350 15107 c-14 -6 -27 -12 -29 -13 -2 -2 13 -30 33 -62 20 -33 43
-76 51 -96 l15 -36 -90 0 -91 0 3 -32 3 -33 93 -3 92 -3 0 -73 c0 -62 3 -74
18 -79 9 -2 25 -8 34 -12 14 -5 17 2 23 49 11 86 -8 187 -53 280 -53 109 -69
128 -102 113z"
      />
      <path
        :fill="color"
        d="M13599 14811 l-17 -29 84 -32 c46 -18 84 -36 84 -40 0 -4 -32 -49
-71 -99 -44 -58 -75 -89 -82 -84 -7 4 -94 71 -194 150 l-182 143 -111 -141
c-60 -77 -110 -144 -110 -148 0 -8 426 -341 437 -341 4 1 89 105 189 233 99
128 190 236 201 241 11 6 25 24 31 42 9 29 7 33 -17 44 -28 13 -219 90 -223
90 -2 0 -10 -13 -19 -29z m-191 -224 c83 -65 152 -122 152 -125 -1 -4 -11 -20
-24 -36 l-24 -29 -165 128 -165 129 25 33 c15 19 30 30 37 26 6 -4 80 -61 164
-126z m-103 -112 c184 -143 170 -126 145 -158 -12 -15 -25 -27 -30 -27 -10 0
-302 227 -315 245 -12 18 32 69 49 57 6 -5 74 -57 151 -117z"
      />
      <path
        :fill="color"
        d="M9008 15213 c-26 -3 -44 -13 -58 -31 -19 -23 -21 -38 -19 -156 l1
-131 -156 -3 -156 -3 0 -34 0 -35 160 0 160 0 0 -25 c0 -19 -20 -39 -92 -94
-137 -103 -138 -104 -138 -146 l0 -37 259 4 c143 2 263 7 267 10 3 4 4 19 0
33 l-6 25 -203 0 -202 1 35 30 c19 17 61 46 93 66 56 35 57 36 57 83 l0 47 98
6 c53 4 125 7 160 7 l62 0 0 30 0 30 -160 0 -161 0 3 128 3 127 58 3 c48 3 57
6 57 22 0 10 -7 26 -16 34 -15 16 -30 17 -106 9z"
      />
      <path
        :fill="color"
        d="M7380 14969 c-157 -43 -290 -81 -297 -83 -20 -8 5 -68 26 -62 126 38
245 66 251 59 9 -10 64 -212 59 -218 -3 -2 -69 -21 -147 -43 -79 -22 -145 -42
-148 -45 -9 -8 8 -57 20 -57 6 0 74 18 151 39 77 22 143 37 146 33 10 -11 61
-203 56 -209 -3 -2 -57 -19 -121 -37 -63 -17 -118 -34 -121 -38 -10 -9 6 -58
19 -58 12 0 559 150 564 155 2 1 -3 16 -10 33 l-13 30 -120 -34 c-65 -18 -121
-32 -123 -30 -6 6 -61 211 -57 214 2 2 67 21 145 42 79 22 145 41 147 44 3 3
2 18 -2 34 l-6 30 -87 -24 c-181 -50 -211 -58 -217 -52 -12 12 -64 213 -57
219 4 4 61 22 127 40 66 17 124 35 128 39 9 8 -9 60 -20 59 -5 0 -136 -36
-293 -80z"
      />
      <path
        :fill="color"
        d="M10246 15087 l-28 -23 74 -69 c42 -39 95 -84 119 -101 l44 -32 28 22
28 23 -58 43 c-32 24 -85 70 -118 101 l-61 58 -28 -22z"
      />
      <path
        :fill="color"
        d="M10672 14934 c-73 -19 -103 -36 -145 -83 l-37 -41 -149 39 -149 39
-6 -31 c-3 -16 -5 -31 -3 -33 1 -1 64 -18 140 -37 76 -19 140 -37 142 -39 4
-3 -13 -79 -19 -85 -1 -1 -32 7 -70 17 -74 21 -86 19 -86 -11 0 -23 -13 -25
-30 -4 -7 9 -31 30 -52 47 l-39 31 -24 -23 -25 -23 57 -52 56 -51 -56 -29
c-60 -30 -66 -39 -43 -70 12 -17 16 -17 70 14 46 27 60 31 71 21 26 -21 17
-38 -35 -66 -52 -28 -60 -43 -35 -64 13 -11 23 -9 54 8 50 28 61 28 61 -2 0
-42 10 -56 42 -56 l31 0 -7 55 c-7 65 -39 153 -68 190 -11 14 -18 28 -15 31 3
3 58 -9 124 -26 65 -17 136 -36 157 -42 l39 -10 -41 -23 c-92 -52 -143 -103
-155 -156 -7 -26 -5 -26 114 -57 67 -18 125 -30 129 -27 4 3 10 16 12 29 5 23
1 26 -84 47 l-89 22 23 24 c13 14 35 31 49 38 24 13 27 12 41 -13 9 -15 25
-36 36 -46 17 -15 24 -16 44 -5 13 6 25 13 27 15 2 2 -10 19 -28 39 -17 20
-31 40 -31 45 0 10 63 30 95 30 37 0 47 14 34 43 -14 31 -34 34 -104 13 l-47
-15 5 29 c6 28 5 28 -64 45 l-71 18 7 36 c4 20 10 39 14 43 4 4 66 -8 139 -27
72 -19 136 -35 141 -35 5 0 14 13 19 29 l10 29 -126 32 c-164 43 -161 41 -122
73 44 37 120 57 217 57 46 0 83 4 83 9 0 5 -4 21 -10 35 -9 25 -13 26 -87 25
-43 0 -102 -7 -131 -15z"
      />
      <path
        :fill="color"
        d="M2398 14617 c-16 -6 -28 -14 -28 -17 0 -20 80 -134 130 -185 l59 -60
-65 -85 -65 -85 21 -17 c12 -10 26 -18 30 -18 4 0 35 36 69 80 l62 79 60 -46
c33 -26 58 -52 55 -59 -8 -20 -138 -184 -146 -184 -4 0 -38 21 -76 46 -38 25
-96 60 -129 76 -33 17 -64 36 -68 42 -9 11 -2 190 9 239 6 25 4 27 -29 27 -43
0 -46 -8 -54 -146 l-6 -102 -57 5 c-75 7 -126 -10 -146 -49 -14 -28 -14 -34 0
-73 9 -23 27 -52 40 -64 23 -22 25 -22 55 -6 l32 16 -36 42 c-33 38 -35 43
-19 54 19 14 68 15 118 4 25 -5 32 -13 42 -51 17 -66 48 -144 78 -195 l27 -45
29 15 30 16 -31 61 c-35 70 -61 139 -55 145 9 10 196 -106 196 -121 0 -4 -30
-46 -66 -93 -66 -85 -72 -103 -35 -122 17 -10 28 -1 90 79 40 50 74 90 77 90
3 0 23 -13 44 -30 21 -16 41 -30 44 -30 3 0 13 12 23 26 17 26 17 27 -25 63
l-42 36 95 120 c52 66 94 123 95 127 0 3 -62 55 -137 116 -145 115 -187 160
-230 242 -14 28 -29 50 -32 49 -3 -1 -18 -6 -33 -12z"
      />
      <path
        :fill="color"
        d="M2547 13801 c-41 -23 -47 -29 -41 -51 8 -37 11 -37 62 -10 39 21 47
30 44 50 -4 38 -13 40 -65 11z"
      />
      <path
        :fill="color"
        d="M15705 14483 c12 -31 45 -165 45 -184 0 -16 -3 -16 -57 1 -32 9 -73
20 -91 23 -33 7 -33 7 -30 -29 3 -36 3 -36 78 -55 41 -11 78 -23 84 -29 6 -6
3 -32 -8 -72 l-17 -63 27 -22 28 -22 14 32 c46 110 52 253 15 372 -18 59 -20
60 -57 63 -34 3 -38 1 -31 -15z"
      />
      <path
        :fill="color"
        d="M15410 14163 c-69 -52 -133 -102 -144 -112 -18 -18 -13 -25 148 -240
110 -146 171 -219 179 -214 7 4 116 84 242 179 127 95 239 174 249 176 10 1
28 15 39 30 l20 27 -29 25 c-16 14 -64 51 -106 81 -76 56 -77 56 -103 39 -14
-9 -24 -20 -23 -24 2 -4 32 -29 67 -56 36 -27 66 -53 67 -59 3 -8 -123 -108
-172 -138 -9 -5 -56 51 -155 180 -78 104 -144 191 -148 194 -3 4 -62 -36 -131
-88z m248 -177 l121 -160 -32 -23 c-17 -13 -35 -22 -39 -21 -4 2 -61 75 -127
163 l-121 160 32 27 c18 16 35 25 39 20 4 -4 61 -79 127 -166z m-123 -88 c124
-167 126 -171 74 -199 -16 -8 -36 14 -139 151 -66 87 -120 164 -120 169 0 13
54 51 61 43 4 -4 59 -78 124 -164z"
      />
      <path
        :fill="color"
        d="M6078 14443 c-74 -77 -142 -171 -168 -232 -11 -28 -16 -31 -59 -31
-38 0 -185 15 -224 23 -12 3 -29 -55 -19 -65 4 -4 64 -13 132 -20 69 -6 126
-13 128 -14 2 -1 -4 -36 -12 -78 -21 -101 -21 -150 0 -142 9 3 24 6 34 6 14 0
19 12 24 62 19 162 98 321 222 445 l82 83 -28 20 c-15 11 -30 20 -32 20 -3 0
-38 -35 -80 -77z"
      />
      <path
        :fill="color"
        d="M6193 14317 c-109 -118 -183 -277 -207 -444 -6 -43 -6 -43 24 -43 33
0 50 26 50 76 0 28 34 63 122 125 l57 40 -16 -38 c-9 -21 -23 -66 -32 -100
l-16 -62 -149 -89 c-82 -48 -151 -93 -153 -98 -2 -6 4 -21 14 -32 l18 -21 125
74 c69 41 129 75 133 75 5 0 23 -11 41 -25 l33 -25 27 29 27 28 -27 20 -27 20
131 77 c73 43 132 83 132 90 0 7 -6 21 -14 32 -12 15 -19 17 -33 8 -147 -87
-193 -112 -193 -101 0 28 33 124 57 165 24 42 24 44 7 63 -9 10 -22 19 -28 19
-6 0 -48 -27 -94 -60 -46 -33 -85 -60 -87 -60 -20 0 92 174 145 225 16 16 30
31 30 35 0 3 -13 13 -29 23 l-29 17 -39 -43z"
      />
      <path
        :fill="color"
        d="M11742 14545 c-7 -14 -12 -28 -12 -30 0 -2 29 -20 64 -40 l65 -36
-70 -100 c-39 -54 -76 -99 -82 -99 -7 0 -30 12 -52 25 -50 31 -51 31 -69 -2
-14 -27 -13 -28 35 -55 27 -16 49 -32 49 -36 -1 -4 -36 -56 -79 -117 -44 -60
-76 -113 -72 -116 11 -12 473 -271 476 -267 5 7 25 47 25 52 0 3 -33 24 -72
47 -40 23 -74 43 -76 45 -3 2 103 141 127 167 4 4 45 -14 91 -40 79 -44 83
-46 96 -28 8 10 14 24 14 31 0 7 -34 31 -76 54 -41 23 -74 45 -72 49 8 19 144
190 151 191 5 0 36 -16 68 -35 33 -19 64 -35 68 -35 4 0 13 12 20 27 10 21 9
28 -1 35 -29 18 -596 338 -600 338 -3 0 -10 -11 -16 -25z m291 -205 c53 -30
97 -59 97 -63 0 -5 -32 -50 -72 -100 -39 -51 -72 -93 -73 -95 -2 -2 -195 105
-203 113 -6 6 139 206 147 203 4 -2 51 -28 104 -58z m-192 -256 c67 -38 97
-60 91 -68 -67 -88 -125 -156 -132 -156 -16 0 -179 94 -180 103 0 8 112 176
118 177 2 0 49 -25 103 -56z"
      />
      <path
        :fill="color"
        d="M3403 13781 l-40 -49 -43 34 c-23 19 -46 34 -50 34 -4 0 -15 -9 -26
-21 -18 -20 -18 -21 29 -62 l47 -42 -40 -52 -39 -51 26 -17 c29 -20 23 -24 87
58 21 27 23 27 39 9 16 -17 15 -21 -13 -59 l-30 -41 110 -86 c60 -47 113 -86
118 -86 4 0 18 16 32 35 27 38 41 43 60 20 10 -12 5 -23 -25 -60 l-37 -45 23
-19 24 -20 32 37 c18 20 32 40 33 45 0 13 27 8 40 -8 18 -21 27 -19 47 11 16
25 16 27 -7 44 -26 20 -26 19 30 92 l21 27 -26 17 c-24 16 -26 16 -44 -7 -57
-73 -54 -71 -76 -55 -19 14 -19 15 11 57 l31 43 -111 88 c-61 48 -113 88 -116
88 -3 0 -18 -18 -33 -40 -25 -35 -30 -38 -47 -27 -11 6 -20 15 -20 18 0 3 16
27 36 53 35 45 35 48 18 67 -9 10 -21 19 -25 19 -4 0 -25 -22 -46 -49z m157
-180 c-5 -9 -25 -34 -44 -56 -33 -39 -34 -40 -54 -21 l-21 18 40 54 c40 52 41
53 65 38 18 -12 21 -20 14 -33z m83 -43 c15 -12 13 -18 -23 -63 -42 -53 -57
-60 -73 -34 -8 13 -2 27 28 63 41 50 44 52 68 34z"
      />
      <path
        :fill="color"
        d="M3097 13579 c-10 -6 -45 -47 -78 -91 -74 -100 -78 -136 -23 -198 38
-42 39 -42 93 -3 2 1 -10 17 -28 35 -17 17 -31 41 -31 53 0 20 94 145 109 145
5 0 14 -6 20 -14 13 -16 46 -170 60 -280 8 -65 14 -83 33 -97 28 -22 26 -23
121 100 72 94 75 99 58 115 -10 9 -22 16 -28 16 -6 0 -35 -30 -64 -67 l-53
-68 -13 90 c-29 209 -60 275 -125 275 -18 0 -41 -5 -51 -11z"
      />
      <path
        :fill="color"
        d="M3460 13351 c0 -6 9 -33 20 -61 11 -28 20 -52 20 -54 0 -2 -36 -50
-80 -107 -44 -56 -80 -106 -80 -110 0 -4 11 -14 23 -22 24 -15 25 -14 93 74
38 49 72 89 76 89 4 0 14 -12 22 -27 32 -59 33 -60 60 -34 l25 24 -35 63 c-19
35 -43 87 -54 116 -17 49 -21 53 -54 56 -20 2 -36 -1 -36 -7z"
      />
      <path
        :fill="color"
        d="M14763 13783 l-21 -4 25 -62 c14 -34 38 -87 53 -118 27 -52 31 -55
59 -51 17 2 31 8 31 12 0 5 -18 45 -39 89 -21 44 -44 94 -49 111 -11 30 -16
31 -59 23z"
      />
      <path
        :fill="color"
        d="M14620 13578 c-58 -43 -109 -83 -114 -88 -5 -5 23 -49 63 -101 56
-72 69 -95 60 -105 -20 -24 -33 -16 -87 56 -46 61 -55 69 -72 60 -10 -5 -22
-15 -25 -20 -5 -7 199 -289 254 -352 3 -4 17 1 30 11 l25 19 -52 70 c-56 75
-60 87 -36 96 22 8 25 6 95 -89 39 -53 67 -81 73 -76 6 4 57 42 114 85 56 42
102 79 102 82 0 5 -297 403 -314 420 -8 9 -38 -8 -116 -68z m147 -70 c57 -76
57 -78 37 -93 -11 -8 -22 -15 -25 -15 -3 0 -27 30 -54 66 -46 63 -48 67 -30
80 10 8 22 14 26 14 3 0 24 -24 46 -52z m-90 -70 c55 -74 55 -73 34 -92 -18
-16 -21 -14 -70 49 -42 54 -50 69 -40 81 20 24 35 16 76 -38z m239 -129 l47
-61 -20 -20 -20 -20 -47 60 c-50 65 -52 72 -34 90 19 19 24 16 74 -49z m-91
-69 c38 -50 45 -63 35 -75 -7 -8 -18 -15 -25 -15 -10 0 -60 61 -88 107 -9 14
8 43 24 43 4 0 29 -27 54 -60z"
      />
      <path
        :fill="color"
        d="M14330 13434 c-25 -20 -47 -37 -49 -39 -2 -2 38 -57 87 -122 l91
-117 -17 -28 c-15 -25 -15 -29 3 -48 22 -24 34 -25 49 -4 10 14 25 -1 99 -100
l87 -116 50 37 c28 21 50 40 50 43 -1 10 -38 50 -48 50 -5 0 -15 -7 -22 -15
-7 -8 -16 -15 -20 -15 -7 0 -301 383 -309 403 -2 5 7 19 19 32 22 23 22 24 4
49 -11 14 -21 25 -24 25 -3 0 -25 -16 -50 -35z"
      />
      <path
        :fill="color"
        d="M14990 13389 c-12 -28 -11 -32 4 -41 10 -6 54 -39 97 -74 l79 -63 15
28 c14 28 14 30 -23 63 -40 36 -148 118 -155 118 -3 0 -10 -14 -17 -31z"
      />
      <path
        :fill="color"
        d="M4900 13485 l-44 -45 -43 42 -43 42 -25 -24 -25 -24 42 -43 42 -43
-44 -45 -44 -45 22 -22 22 -22 44 43 c38 38 47 42 61 31 22 -18 19 -30 -17
-68 l-33 -34 104 -99 105 -100 38 38 c36 35 39 36 55 20 16 -16 15 -20 -27
-62 l-44 -45 22 -22 22 -22 45 44 45 44 23 -22 23 -22 22 23 22 23 -22 22 -22
22 44 45 45 46 -25 19 -25 19 -43 -42 c-39 -38 -43 -40 -58 -25 -16 15 -14 20
16 58 l33 42 -101 101 -102 101 -38 -37 c-36 -35 -39 -36 -55 -20 -16 16 -14
20 28 63 l45 46 -23 22 -23 22 -44 -45z m95 -235 l-49 -50 -20 20 -20 20 49
50 49 50 20 -20 20 -20 -49 -50z m115 -15 c11 -14 6 -23 -35 -65 -46 -47 -50
-49 -67 -33 -17 15 -16 18 25 64 46 51 58 57 77 34z"
      />
      <path
        :fill="color"
        d="M4572 13313 c-18 -9 -62 -47 -97 -86 -58 -62 -65 -74 -65 -110 0 -28
8 -51 27 -76 14 -20 27 -37 29 -39 1 -2 16 4 33 12 l30 16 -24 36 c-14 20 -25
44 -25 53 0 24 115 135 133 128 21 -8 26 -44 34 -219 5 -143 8 -159 27 -177
l22 -21 99 100 100 100 -23 22 -22 22 -64 -63 -63 -63 -7 119 c-10 157 -19
201 -47 228 -34 32 -59 37 -97 18z"
      />
      <path
        :fill="color"
        d="M4917 12994 l15 -66 -91 -92 c-50 -50 -91 -96 -91 -102 0 -6 8 -18
19 -28 17 -16 22 -12 102 69 l83 86 23 -46 c26 -50 29 -52 60 -30 l22 15 -22
48 c-11 26 -31 83 -42 127 -22 80 -22 80 -58 83 l-35 3 15 -67z"
      />
      <path
        :fill="color"
        d="M13103 13658 c-33 -8 -42 -21 -24 -33 9 -5 71 -155 71 -170 0 -3 -40
-3 -90 1 l-90 7 0 -37 0 -36 53 0 c28 0 69 -5 91 -11 l39 -11 -7 -69 c-6 -68
-6 -68 23 -84 17 -8 32 -11 35 -6 13 21 27 168 21 214 -9 61 -34 136 -66 198
-23 44 -25 46 -56 37z"
      />
      <path
        :fill="color"
        d="M12815 13260 l-130 -130 200 -201 200 -200 217 220 c119 122 223 221
231 221 19 0 43 58 30 71 -15 15 -207 119 -219 119 -7 0 -19 -11 -28 -24 l-16
-25 80 -42 c44 -24 80 -45 80 -49 0 -3 -38 -44 -85 -90 l-85 -85 -173 173
-172 172 -130 -130z m425 -260 c0 -3 -13 -18 -28 -33 l-28 -27 -149 144 -150
144 29 30 29 31 148 -141 c82 -78 149 -144 149 -148z m-251 36 l144 -145 -17
-25 c-9 -14 -22 -26 -29 -26 -7 0 -77 65 -157 145 l-144 144 24 26 c13 14 26
25 29 25 4 0 71 -65 150 -144z"
      />
      <path
        :fill="color"
        d="M1291 12618 c-10 -24 -35 -82 -56 -130 -21 -49 -43 -88 -51 -88 -7 0
-38 11 -69 24 l-55 25 -15 -29 c-8 -16 -15 -31 -15 -33 0 -3 29 -17 65 -32 36
-16 65 -32 65 -37 0 -6 -22 -62 -50 -126 -27 -64 -50 -121 -50 -127 0 -6 12
-16 28 -21 29 -10 28 -13 127 223 l14 33 43 -20 c23 -10 44 -23 46 -29 2 -5
-22 -68 -52 -140 -31 -71 -56 -134 -56 -139 0 -8 50 -36 55 -30 1 2 19 42 40
90 l37 88 21 -28 c11 -15 32 -39 46 -54 23 -26 26 -27 48 -13 29 20 29 9 -2
-61 -14 -31 -25 -59 -25 -63 0 -4 13 -12 29 -18 l29 -10 54 126 54 126 57 9
c56 9 57 10 57 42 0 31 -2 33 -39 36 l-38 3 53 124 c30 69 54 128 54 132 0 4
-13 12 -29 17 l-30 11 -28 -70 c-30 -73 -40 -83 -45 -46 -3 20 -9 22 -71 25
-78 3 -77 -4 -25 111 28 62 28 66 11 79 -10 7 -24 11 -32 10 -8 -2 -41 -63
-73 -137 -32 -74 -60 -136 -62 -139 -7 -6 -96 29 -96 38 0 4 11 32 24 61 13
30 37 87 54 126 l31 73 -30 15 -29 16 -19 -43z m319 -284 c0 -6 -111 -267
-116 -273 -9 -10 -114 115 -114 137 0 5 11 35 24 68 24 59 24 59 73 65 68 8
133 10 133 3z"
      />
      <path
        :fill="color"
        d="M16894 12548 c3 -18 11 -67 17 -108 17 -107 23 -120 59 -120 16 0 30
2 30 4 0 3 -6 35 -14 73 -8 37 -17 94 -21 126 l-6 57 -35 0 c-34 0 -35 -1 -30
-32z"
      />
      <path
        :fill="color"
        d="M16720 12418 c-69 -27 -128 -53 -132 -56 -3 -4 13 -56 37 -115 44
-108 44 -108 22 -117 -28 -10 -29 -9 -62 78 -16 40 -32 75 -36 78 -4 2 -19 0
-33 -6 l-25 -9 71 -173 c38 -95 76 -187 83 -205 13 -30 16 -32 43 -22 l30 10
-35 86 c-27 68 -32 88 -21 94 27 17 35 7 71 -83 21 -51 41 -99 46 -106 6 -10
36 -2 137 38 71 29 130 53 131 54 2 2 -170 434 -195 488 -6 14 -22 10 -132
-34z m129 -115 c24 -59 28 -79 19 -85 -31 -19 -45 -7 -71 60 -36 90 -35 92 14
101 4 0 21 -34 38 -76z m-105 -42 c29 -74 29 -85 -3 -94 -15 -3 -22 2 -29 22
-5 14 -19 50 -31 79 l-21 53 23 8 c12 5 25 7 28 5 3 -1 18 -35 33 -73z m195
-179 c29 -69 29 -72 11 -82 -10 -5 -23 -10 -28 -10 -8 0 -62 124 -62 143 0 7
42 27 47 23 2 -1 16 -35 32 -74z m-105 -43 c23 -58 26 -73 15 -80 -26 -17 -41
-4 -70 65 -23 54 -27 71 -17 78 30 18 44 6 72 -63z"
      />
      <path
        :fill="color"
        d="M16393 12350 c-24 -11 -43 -23 -43 -28 0 -4 23 -64 50 -132 28 -68
50 -129 50 -135 0 -7 -9 -20 -20 -30 -19 -18 -19 -23 9 -65 8 -12 12 -12 28 3
18 16 21 11 72 -118 l54 -133 51 19 c65 26 69 31 55 62 -14 30 -17 31 -52 18
-23 -9 -26 -4 -115 217 -50 125 -94 234 -97 243 -5 12 2 20 24 27 29 10 30 12
20 41 -13 36 -26 37 -86 11z"
      />
      <path
        :fill="color"
        d="M17031 12142 l-20 -29 39 -47 c22 -27 54 -70 72 -97 l32 -50 25 25
25 25 -37 53 c-20 29 -54 74 -76 101 l-39 47 -21 -28z"
      />
      <path
        :fill="color"
        d="M3803 12348 c-13 -6 -23 -17 -23 -25 0 -15 133 -152 187 -194 l33
-24 -52 -89 -51 -89 24 -18 c13 -10 26 -19 29 -19 3 0 27 39 54 88 27 48 50
89 52 91 5 6 134 -70 134 -79 0 -7 -105 -197 -117 -209 -2 -3 -34 10 -71 28
-37 19 -103 46 -147 61 -93 32 -93 31 -102 191 l-6 106 -31 -6 -31 -7 0 -79
c0 -44 3 -99 6 -121 l7 -41 -58 -6 c-149 -13 -190 -98 -92 -190 24 -23 34 -27
48 -18 49 27 49 28 10 61 -59 52 -38 76 71 79 l43 1 29 -64 c30 -66 78 -143
114 -183 19 -21 21 -21 43 -5 30 22 30 26 -5 70 -16 20 -44 63 -62 96 -32 58
-32 58 -8 51 56 -17 192 -80 196 -91 2 -7 -18 -52 -46 -101 -28 -49 -51 -94
-51 -101 0 -11 31 -32 47 -32 5 0 16 12 24 28 9 15 35 60 58 100 l42 73 46
-27 46 -27 19 23 c10 12 18 26 18 31 0 4 -20 20 -45 35 -25 14 -45 28 -45 31
0 3 34 65 76 140 42 74 74 136 73 137 -2 2 -67 39 -143 82 -139 79 -248 165
-283 225 -19 31 -26 33 -60 17z"
      />
      <path
        :fill="color"
        d="M4071 11562 c-42 -37 -43 -39 -29 -66 l14 -27 47 36 c47 36 47 36 32
65 -9 17 -17 30 -18 30 -1 0 -22 -18 -46 -38z"
      />
      <path
        :fill="color"
        d="M14130 12445 c0 -13 73 -231 79 -238 4 -4 21 -5 37 -1 l29 6 -39 119
-40 119 -33 0 c-18 0 -33 -2 -33 -5z"
      />
      <path
        :fill="color"
        d="M13980 12260 c-63 -38 -116 -73 -117 -77 -2 -5 22 -51 52 -102 30
-51 55 -96 55 -100 0 -3 -9 -12 -19 -18 -18 -11 -24 -5 -66 67 -26 44 -49 80
-52 80 -12 0 -43 -22 -43 -31 0 -13 213 -379 220 -379 3 0 15 8 27 18 l22 17
-46 78 c-37 64 -43 81 -32 88 27 17 35 9 90 -86 30 -52 57 -94 60 -95 4 0 61
32 127 71 l121 71 -55 91 c-29 51 -91 156 -136 234 -46 79 -85 142 -88 142 -3
0 -57 -32 -120 -69z m150 -92 c39 -67 40 -73 24 -85 -10 -7 -21 -13 -25 -13
-9 0 -94 139 -88 144 4 3 43 25 46 26 1 0 20 -32 43 -72z m-96 -63 c37 -65 38
-69 21 -81 -10 -8 -21 -14 -24 -14 -3 0 -25 33 -48 72 -38 66 -40 73 -25 85
26 19 34 12 76 -62z m183 -87 c5 -7 24 -38 41 -69 l32 -57 -23 -15 c-23 -15
-24 -14 -65 55 -40 66 -42 71 -25 84 23 17 28 17 40 2z m-63 -115 c37 -63 38
-67 20 -80 -10 -7 -21 -13 -24 -13 -8 0 -80 124 -80 138 0 10 16 20 35 21 6 0
27 -29 49 -66z"
      />
      <path
        :fill="color"
        d="M13678 12150 c-27 -17 -48 -32 -48 -34 0 -3 33 -60 73 -129 l74 -124
-20 -27 -20 -28 26 -26 c26 -25 27 -26 40 -7 13 17 20 8 86 -103 39 -67 74
-122 78 -122 13 0 103 54 103 62 0 5 -7 20 -16 33 -15 23 -17 24 -45 10 -27
-14 -29 -14 -43 7 -7 13 -66 113 -131 222 l-116 199 27 22 c26 21 27 22 9 48
-9 15 -20 27 -24 27 -3 0 -27 -14 -53 -30z"
      />
      <path
        :fill="color"
        d="M14331 12033 c-12 -25 -9 -30 71 -110 45 -46 86 -83 89 -83 4 0 14
12 23 26 l17 25 -84 85 c-46 46 -89 84 -94 84 -5 0 -15 -12 -22 -27z"
      />
      <path
        :fill="color"
        d="M2277 12242 c-15 -9 -27 -21 -27 -26 0 -22 112 -113 227 -182 17 -10
15 -17 -24 -108 l-42 -97 32 -14 32 -13 38 91 c22 51 41 94 43 96 5 6 144 -49
144 -57 0 -19 -94 -222 -103 -222 -5 0 -53 14 -105 30 -52 17 -115 33 -139 37
-30 4 -49 13 -58 27 -17 26 -45 139 -45 186 0 52 -12 64 -46 53 -27 -9 -29
-13 -26 -54 3 -44 25 -149 37 -181 6 -14 2 -18 -17 -18 -45 0 -124 -29 -148
-55 -34 -37 -31 -78 11 -121 50 -53 63 -57 93 -33 l27 21 -41 35 c-22 20 -39
40 -37 46 5 16 66 35 112 36 39 0 41 -2 75 -61 19 -33 60 -88 91 -122 l57 -61
26 24 25 24 -57 62 c-31 35 -65 77 -76 95 -21 37 -35 38 113 -6 51 -15 95 -33
98 -40 2 -6 -14 -55 -36 -107 -23 -53 -41 -98 -41 -101 0 -3 13 -12 29 -20
l29 -15 47 109 c26 61 49 110 50 110 2 0 24 -9 50 -20 26 -11 48 -20 50 -20 5
0 28 61 24 64 -2 2 -25 13 -51 24 l-47 20 60 141 c32 77 59 144 59 148 0 5
-57 33 -127 62 -171 72 -227 104 -298 172 l-60 58 -28 -17z"
      />
      <path
        :fill="color"
        d="M2628 11491 c-43 -44 -45 -52 -20 -74 17 -16 21 -14 57 23 36 37 38
41 25 65 -7 14 -16 25 -19 25 -3 -1 -23 -18 -43 -39z"
      />
      <path
        :fill="color"
        d="M15408 11947 c-109 -44 -198 -86 -198 -91 0 -6 52 -139 116 -297
l116 -287 201 81 c111 44 204 82 206 84 3 2 -18 60 -46 131 -28 70 -49 130
-47 133 1 3 52 25 113 48 l109 43 -13 32 c-8 17 -20 30 -28 28 -8 -1 -58 -20
-112 -42 -54 -22 -99 -40 -101 -40 -1 0 -26 59 -55 130 -29 72 -56 130 -59
129 -3 0 -94 -37 -202 -82z m213 -110 l37 -92 -50 -22 c-28 -13 -54 -23 -58
-23 -7 0 -80 170 -80 185 0 8 81 43 100 44 10 1 27 -31 51 -92z m-199 -19 c9
-24 25 -67 37 -95 l21 -53 -34 -14 c-76 -32 -70 -35 -110 60 -20 47 -36 91
-36 98 0 11 69 43 95 45 6 1 18 -18 27 -41z m303 -238 c22 -53 34 -94 29 -99
-12 -11 -104 -45 -108 -40 -1 2 -19 45 -39 94 l-36 90 47 22 c26 12 52 22 58
22 6 1 28 -40 49 -89z m-179 -70 c19 -46 34 -88 34 -92 0 -8 -83 -48 -98 -48
-6 0 -67 147 -74 178 -3 13 77 53 96 49 4 -2 23 -41 42 -87z"
      />
      <path
        :fill="color"
        d="M3257 10843 c-2 -5 -19 -66 -37 -138 -19 -71 -34 -131 -35 -133 -2
-2 -33 5 -69 14 -71 18 -82 15 -88 -25 -3 -22 3 -26 61 -42 35 -10 66 -20 68
-23 3 -3 -9 -64 -27 -135 -17 -71 -29 -134 -26 -139 5 -9 56 -23 56 -16 0 10
70 267 73 271 9 8 97 -20 97 -31 0 -7 -16 -74 -35 -149 -20 -76 -34 -141 -31
-146 3 -5 17 -11 31 -13 22 -5 26 -1 36 36 6 23 17 65 26 95 l15 53 47 -46
c52 -51 57 -53 83 -29 23 20 24 7 3 -61 -8 -27 -15 -55 -15 -61 0 -16 53 -26
62 -12 4 6 19 61 34 122 15 60 31 117 35 126 5 10 27 19 53 23 53 8 55 11 49
54 -4 26 -9 32 -24 27 -11 -3 -28 -7 -38 -10 -18 -6 -17 3 15 127 19 73 32
138 30 144 -2 6 -16 14 -30 16 -27 5 -33 -6 -52 -100 -8 -42 -20 -49 -28 -17
-7 29 -11 29 -88 11 -32 -8 -58 -11 -58 -8 0 4 11 48 24 97 13 50 23 91 22 92
-1 2 -16 5 -32 9 l-30 6 -39 -149 c-21 -81 -40 -150 -41 -152 -2 -2 -26 2 -54
9 -39 9 -50 16 -46 29 16 51 66 264 64 266 -10 8 -57 14 -61 8z m312 -409
c-21 -81 -40 -149 -43 -152 -10 -10 -136 121 -132 137 2 9 11 41 20 71 l15 56
73 16 c40 8 80 16 89 17 15 1 11 -20 -22 -145z"
      />
      <path
        :fill="color"
        d="M14452 10860 c-112 -32 -205 -59 -207 -62 -5 -5 158 -595 167 -604 5
-4 411 101 425 110 1 1 -14 61 -34 134 -20 72 -34 134 -31 137 3 4 56 20 117
37 109 30 111 31 105 57 -4 14 -10 30 -14 34 -4 4 -57 -6 -119 -24 -62 -17
-114 -29 -115 -27 -4 3 -44 143 -66 226 -6 23 -14 41 -18 41 -4 -1 -98 -27
-210 -59z m199 -131 c15 -52 24 -97 20 -100 -12 -12 -104 -30 -111 -22 -9 9
-50 156 -50 178 0 13 83 45 105 41 6 -2 22 -45 36 -97z m-187 -44 c14 -52 26
-99 26 -103 0 -9 -100 -35 -108 -28 -5 6 -51 167 -52 183 0 9 63 36 101 42 4
1 18 -42 33 -94z m246 -167 c6 -24 18 -67 26 -95 9 -29 13 -57 10 -62 -5 -8
-82 -31 -104 -31 -9 0 -67 188 -60 195 3 3 97 32 110 34 4 1 12 -18 18 -41z
m-169 -114 l27 -95 -23 -9 c-13 -5 -38 -12 -57 -15 l-35 -7 -23 89 c-12 48
-25 93 -27 99 -4 10 97 45 107 36 3 -2 17 -46 31 -98z"
      />
      <path
        :fill="color"
        d="M477 10523 c-4 -3 -7 -19 -7 -35 0 -21 5 -28 20 -28 26 0 26 -5 -10
-255 -16 -114 -30 -209 -30 -211 0 -2 -11 -4 -24 -4 -18 0 -25 -7 -30 -32 -3
-17 -5 -32 -3 -34 3 -4 504 -74 527 -74 15 0 19 16 30 96 l13 96 39 -5 c22 -3
41 -7 43 -9 2 -2 -2 -46 -10 -98 -20 -133 -20 -137 13 -143 15 -3 28 -4 29 -3
1 1 24 158 50 348 52 366 52 358 4 358 -15 0 -20 -18 -34 -117 -9 -64 -19
-118 -21 -120 -2 -2 -20 -1 -40 2 -42 8 -43 14 -25 126 6 39 9 73 6 75 -4 5
-490 74 -518 74 -8 0 -19 -3 -22 -7z m203 -89 c59 -6 120 -21 95 -24 -5 0 -18
-7 -28 -14 -17 -14 -17 -16 8 -65 27 -55 86 -105 136 -116 31 -7 33 -13 23
-64 l-7 -32 -56 7 c-31 4 -65 7 -76 6 -33 -2 -52 -37 -60 -107 -3 -35 -10 -67
-13 -69 -4 -2 -48 1 -97 8 l-90 12 3 29 c2 17 17 122 33 234 16 112 29 205 29
208 0 2 8 2 18 -1 9 -2 46 -8 82 -12z m205 -29 c28 -4 53 -9 56 -11 6 -4 -7
-103 -15 -111 -11 -11 -79 33 -102 66 -29 43 -32 75 -6 68 9 -3 40 -8 67 -12z
m163 -222 c21 -5 23 -10 17 -42 -4 -20 -8 -38 -10 -39 -2 -2 -21 -1 -42 3 -38
6 -38 7 -35 45 4 42 16 48 70 33z m-170 -129 c24 -5 24 -14 6 -101 -5 -25 -24
-28 -84 -17 l-32 7 6 56 c4 30 11 58 17 62 10 6 35 4 87 -7z"
      />
      <path
        :fill="color"
        d="M649 10388 c-6 -13 -55 -375 -52 -380 2 -5 15 -8 28 -8 29 0 28 -4
55 192 26 194 26 198 -5 198 -14 0 -26 -1 -26 -2z"
      />
      <path
        :fill="color"
        d="M17125 10333 c-110 -14 -202 -27 -204 -28 -3 -4 67 -600 74 -621 2
-7 73 -2 219 16 119 15 218 29 220 31 3 3 -13 146 -28 245 l-4 32 96 11 c156
19 152 17 145 54 -3 18 -7 33 -8 34 -1 2 -53 -4 -115 -12 -63 -8 -117 -15
-120 -15 -4 0 -13 48 -19 108 -17 157 -21 172 -40 171 -9 -1 -106 -13 -216
-26z m175 -55 c9 -64 27 -203 26 -205 -1 -1 -29 -5 -62 -8 l-61 -7 -12 89
c-16 129 -18 121 37 126 26 2 53 4 60 5 6 1 12 1 12 0z m-175 -147 c8 -89 12
-84 -72 -94 -36 -4 -37 -1 -49 126 -7 84 -9 82 71 89 36 4 40 -5 50 -121z
m223 -233 c7 -55 11 -103 9 -104 -2 -2 -30 -5 -62 -6 l-59 -3 -12 95 c-6 52
-8 98 -5 102 3 4 24 8 46 11 22 2 47 4 56 5 12 2 18 -18 27 -100z m-190 -27
c6 -52 10 -97 8 -99 -2 -2 -28 -6 -58 -9 l-54 -5 -12 97 c-7 54 -10 100 -7
104 8 8 99 18 106 12 3 -4 11 -49 17 -100z"
      />
      <path
        :fill="color"
        d="M1806 10343 c-3 -16 -13 -80 -22 -143 -9 -63 -17 -116 -17 -116 -1
-1 -33 3 -70 8 -37 6 -69 9 -71 7 -2 -2 -7 -18 -10 -35 l-7 -31 71 -11 c40 -6
73 -12 75 -14 1 -2 -6 -61 -16 -133 -24 -167 -25 -155 14 -155 l34 0 18 141
19 141 50 -7 c28 -3 52 -8 54 -10 2 -2 -6 -67 -17 -145 -27 -181 -28 -170 13
-170 l33 0 7 63 c4 34 9 76 12 94 l6 32 52 -39 c29 -22 57 -40 63 -40 6 0 18
10 26 23 19 27 21 15 7 -68 -10 -64 -5 -75 36 -75 19 0 22 10 40 137 l19 138
51 18 c50 18 51 19 45 50 -7 33 -24 39 -63 22 -23 -9 -23 -4 1 153 10 67 15
124 13 127 -3 3 -18 5 -33 5 -24 0 -28 -4 -34 -42 -3 -24 -9 -58 -12 -77 l-6
-34 -14 26 c-7 15 -15 27 -16 27 -2 0 -29 -9 -61 -20 -32 -12 -61 -19 -64 -16
-3 3 0 43 6 88 16 112 17 108 -21 108 l-33 0 -18 -144 c-11 -80 -22 -149 -26
-155 -4 -7 -24 -9 -53 -5 -55 8 -53 -4 -31 162 15 106 15 125 3 133 -27 17
-47 10 -53 -18z m380 -220 c-2 -10 -13 -78 -22 -150 -12 -90 -22 -133 -30
-133 -14 0 -139 98 -139 108 0 4 4 37 8 74 l8 66 77 25 c95 31 105 32 98 10z"
      />
      <path
        :fill="color"
        d="M15967 10210 c-120 -15 -221 -31 -224 -33 -5 -6 26 -269 33 -276 3
-4 585 65 637 75 23 5 27 10 27 40 0 19 -2 34 -5 34 -2 0 -133 -16 -289 -35
-157 -19 -292 -35 -300 -35 -10 0 -16 18 -21 65 -4 36 -6 68 -3 70 2 2 89 15
193 28 199 26 215 24 215 -17 0 -11 3 -31 6 -43 5 -20 8 -20 37 -8 18 7 32 18
31 24 -1 6 -2 29 -2 50 -3 53 -28 81 -77 86 -22 2 -138 -9 -258 -25z"
      />
      <path
        :fill="color"
        d="M16023 9842 c-73 -10 -134 -20 -136 -22 -3 -3 -2 -20 0 -37 4 -27 9
-32 27 -28 11 2 64 9 116 15 52 6 104 13 116 15 16 4 28 -8 58 -61 21 -36 36
-67 33 -70 -7 -7 -320 -45 -334 -40 -6 3 -14 20 -18 38 -4 18 -25 71 -47 117
l-40 84 -26 -26 -26 -26 31 -63 c17 -35 41 -97 53 -137 l22 -72 37 5 c117 19
376 46 391 41 10 -3 29 0 43 6 l26 12 -31 60 c-17 34 -41 78 -54 99 -20 31
-21 38 -9 38 54 0 119 -56 158 -137 12 -24 24 -43 28 -43 4 0 17 9 30 19 24
19 24 19 6 57 -32 69 -70 115 -114 141 -57 33 -161 38 -340 15z"
      />
      <path
        :fill="color"
        d="M3462 9208 l3 -123 -42 -3 -43 -3 0 100 0 101 -275 0 -275 0 0 -34
c0 -28 4 -35 23 -38 l22 -3 3 -237 2 -238 -25 0 c-22 0 -25 -4 -25 -35 l0 -35
275 0 275 0 0 100 0 100 45 0 45 0 0 -120 0 -120 30 0 30 0 0 355 0 355 -36 0
-35 0 3 -122z m-340 -21 c-21 -22 -21 -23 -3 -52 28 -47 87 -93 133 -105 24
-6 49 -13 56 -15 7 -3 12 -21 12 -45 l0 -40 -68 0 c-102 0 -112 -11 -112 -116
l0 -84 -93 0 -94 0 -6 107 c-4 58 -7 166 -7 240 l0 133 102 0 101 0 -21 -23z
m188 -38 c0 -58 -1 -60 -22 -53 -57 17 -128 76 -128 105 0 5 34 9 75 9 l75 0
0 -61z m160 -179 l0 -40 -45 0 -45 0 0 40 0 40 45 0 45 0 0 -40z m-152 -172
l-3 -63 -57 -3 -58 -3 0 59 c0 32 3 62 7 65 3 4 31 7 60 7 l54 0 -3 -62z"
      />
      <path
        :fill="color"
        d="M3020 8965 l0 -195 30 0 30 0 0 195 0 195 -30 0 -30 0 0 -195z"
      />
      <path
        :fill="color"
        d="M14534 9268 c3 -78 8 -144 11 -146 2 -2 152 -1 334 3 l331 8 0 33 0
34 -299 0 -298 0 -7 60 c-4 33 -4 65 -1 70 9 15 388 13 403 -2 7 -7 12 -31 12
-54 l0 -42 35 11 c34 10 35 11 35 64 0 44 -5 58 -25 78 l-24 25 -257 0 -257 0
7 -142z"
      />
      <path
        :fill="color"
        d="M14522 9047 l-21 -22 23 -65 c13 -36 29 -97 36 -137 l12 -72 231 -3
c128 -2 240 1 250 5 21 10 19 19 -28 130 -27 61 -30 77 -18 77 45 0 109 -70
136 -150 17 -52 26 -57 57 -32 23 18 23 19 6 69 -20 59 -64 125 -101 149 -48
31 -134 44 -302 44 l-163 0 0 -35 0 -35 138 0 139 0 27 -62 c14 -35 26 -69 26
-75 0 -10 -41 -13 -170 -13 l-170 0 -5 28 c-18 82 -27 117 -46 167 -11 30 -24
55 -28 55 -4 0 -17 -10 -29 -23z"
      />
      <path
        :fill="color"
        d="M805 8318 c-144 -18 -285 -19 -372 -2 -28 5 -33 2 -47 -24 l-15 -30
47 -13 c26 -7 105 -14 177 -15 71 -2 131 -7 132 -11 2 -5 9 -54 16 -111 l13
-102 -32 0 c-36 0 -38 5 -49 113 -7 62 -9 67 -31 67 -33 0 -36 -13 -25 -95 6
-38 8 -71 6 -73 -7 -7 -68 34 -97 65 -14 15 -42 51 -60 80 l-34 51 -24 -18
-25 -19 25 -48 c31 -61 118 -148 165 -164 19 -7 35 -15 35 -19 0 -3 -16 -20
-35 -39 -41 -41 -87 -126 -109 -200 -21 -70 -21 -67 13 -79 30 -11 30 -11 46
46 25 86 91 202 115 202 4 0 11 -36 15 -81 l7 -80 63 6 62 7 7 -36 c6 -30 11
-36 31 -36 22 0 25 4 25 39 0 42 13 51 79 51 l33 0 -8 78 c-12 124 -12 127 14
130 16 3 22 8 18 19 -3 8 -6 23 -6 32 0 14 -6 17 -24 14 -23 -5 -24 -2 -36 96
l-12 101 -30 0 -29 0 8 -62 c4 -35 8 -81 8 -103 0 -36 -3 -40 -26 -43 -25 -3
-26 -2 -37 92 -19 154 -26 141 76 154 48 6 90 7 93 4 4 -4 21 -134 40 -289
l33 -283 27 0 c15 0 30 3 32 8 3 4 -4 72 -14 151 -18 136 -18 145 -1 157 9 7
21 14 26 14 7 0 0 70 -9 78 -2 2 -13 -1 -24 -8 -12 -6 -21 -9 -21 -8 0 2 -7
57 -15 123 -8 65 -15 123 -15 127 0 12 -56 8 -225 -14z m79 -400 c3 -18 8 -50
11 -70 6 -37 5 -38 -24 -38 -33 0 -34 3 -45 86 -6 46 -2 54 30 54 18 0 24 -7
28 -32z m-114 -10 c0 -18 3 -49 6 -69 6 -33 4 -37 -21 -43 -16 -4 -31 -3 -36
1 -4 4 -10 38 -14 76 l-7 67 36 0 c34 0 36 -2 36 -32z"
      />
      <path
        :fill="color"
        d="M2193 8478 c4 -40 10 -96 13 -124 l7 -52 -41 -4 c-47 -4 -47 -5 -58
110 -3 40 -10 75 -14 77 -4 3 -128 -10 -274 -27 l-267 -32 3 -35 c3 -30 7 -36
28 -36 l24 0 29 -225 c15 -123 25 -230 23 -237 -3 -7 -14 -13 -24 -13 -15 0
-17 -6 -14 -35 2 -19 9 -35 16 -34 6 0 128 15 271 33 l260 32 -2 24 c0 14 -4
60 -8 103 l-8 77 41 0 c45 0 46 -1 57 -115 11 -110 13 -115 46 -115 19 0 29 5
29 15 0 8 -18 159 -40 337 -22 178 -40 329 -40 336 0 7 -13 12 -31 12 l-32 0
6 -72z m-138 -123 c4 -31 5 -58 2 -61 -21 -21 -163 62 -154 90 3 10 55 21 119
24 25 2 27 -1 33 -53z m-195 10 l-24 -25 50 -48 c49 -47 106 -72 162 -72 20 0
32 -25 32 -66 0 -19 -7 -22 -66 -29 -89 -9 -108 -28 -99 -98 3 -29 8 -64 11
-79 7 -33 -7 -38 -116 -41 l-74 -2 -28 229 c-16 126 -27 230 -25 232 3 3 140
21 176 23 l24 1 -23 -25z m364 -151 c3 -9 6 -26 6 -39 0 -19 -6 -24 -37 -27
-43 -6 -53 3 -53 50 0 31 2 32 39 32 26 0 41 -5 45 -16z m-126 -211 l8 -61
-29 -6 c-83 -17 -97 -6 -97 76 0 31 4 39 23 43 22 5 80 11 84 9 2 0 7 -28 11
-61z"
      />
      <path
        :fill="color"
        d="M1778 8333 c-22 -5 -22 1 5 -213 l23 -175 24 3 c14 2 27 6 29 8 4 4
-5 85 -31 297 -6 52 -15 87 -22 86 -6 -1 -19 -3 -28 -6z"
      />
      <path
        :fill="color"
        d="M16198 8330 c-13 -23 -14 -32 -5 -35 6 -2 44 -13 83 -24 105 -31 110
-39 95 -163 -15 -125 -49 -337 -57 -349 -12 -20 -55 -8 -89 27 -85 84 -267
337 -340 473 -21 38 -35 52 -57 57 -17 3 -33 2 -38 -2 -7 -9 -82 -535 -77
-541 2 -1 17 -5 33 -9 l30 -6 28 199 c15 109 29 204 32 212 2 8 43 -46 92
-120 110 -167 230 -312 290 -350 71 -45 127 -37 157 21 19 37 79 473 71 516
-9 44 -42 70 -126 99 -93 32 -101 31 -122 -5z"
      />
      <path
        :fill="color"
        d="M16976 8095 c-10 -75 -17 -138 -15 -140 6 -5 661 -97 664 -93 1 2 5
17 8 34 7 38 42 29 -323 80 -146 20 -267 38 -268 39 -2 2 -1 33 3 69 7 66 7
66 39 66 45 -1 353 -47 366 -55 8 -5 10 -24 6 -57 l-7 -50 33 7 c41 9 39 6 48
56 10 52 -4 93 -35 107 -23 11 -433 72 -479 72 -21 0 -23 -8 -40 -135z"
      />
      <path
        :fill="color"
        d="M16936 7883 c-24 -13 -27 -19 -22 -46 3 -18 11 -83 17 -145 11 -101
14 -113 33 -117 12 -3 104 -16 205 -30 101 -14 189 -29 195 -34 16 -13 66 -1
66 16 0 15 -36 160 -46 187 -9 24 24 10 63 -27 31 -29 53 -80 68 -154 4 -18 8
-33 9 -33 2 0 17 5 34 11 28 10 31 14 26 42 -27 158 -82 219 -226 251 -74 17
-308 50 -312 45 -2 -2 -6 -18 -9 -35 l-6 -32 135 -17 c101 -13 137 -22 143
-34 12 -22 40 -129 35 -134 -2 -2 -75 7 -161 19 -87 13 -163 24 -169 24 -7 0
-13 34 -17 88 -3 48 -12 106 -19 129 l-13 42 -29 -16z"
      />
      <path
        :fill="color"
        d="M3430 7789 c-198 -55 -308 -74 -384 -66 -51 5 -53 4 -64 -26 -6 -17
-10 -33 -7 -35 13 -14 144 -12 239 3 59 9 109 15 111 13 6 -6 55 -183 55 -199
0 -11 -10 -18 -29 -21 -29 -4 -30 -3 -54 81 -22 78 -26 86 -48 83 -12 -1 -25
-5 -27 -7 -3 -3 4 -37 16 -77 11 -40 19 -75 16 -77 -12 -13 -119 57 -165 107
-48 53 -50 54 -69 37 -27 -24 -26 -31 16 -81 43 -53 109 -100 169 -121 25 -8
45 -17 45 -20 0 -2 -12 -20 -26 -39 -55 -72 -104 -265 -73 -285 30 -19 48 -10
54 29 12 77 27 127 52 179 15 29 29 53 33 53 4 0 17 -34 29 -75 13 -44 27 -75
35 -75 7 0 34 6 59 14 51 15 52 15 61 -30 7 -29 10 -31 34 -24 15 4 26 13 24
21 -16 67 -18 65 42 78 31 7 56 15 56 17 0 3 -12 46 -26 96 -25 92 -25 99 9
111 5 1 5 15 1 31 -5 23 -11 27 -30 23 -21 -4 -25 1 -35 37 -41 156 -40 153
-65 148 -14 -2 -26 -7 -28 -11 -3 -4 7 -47 20 -96 20 -71 23 -90 12 -96 -35
-23 -45 -10 -73 94 -15 56 -28 106 -29 111 -1 9 133 54 165 55 12 1 31 -53 82
-241 37 -134 72 -260 77 -281 10 -34 13 -37 38 -31 15 4 28 8 30 10 2 1 -14
67 -36 146 l-41 143 24 25 c23 24 23 26 6 58 -16 30 -18 31 -33 15 -20 -20
-16 -29 -59 127 -17 63 -32 116 -33 116 0 1 -80 -20 -176 -47z m111 -436 l17
-61 -25 -7 c-32 -8 -36 -3 -56 67 -16 60 -12 69 27 65 15 -2 24 -17 37 -64z
m-117 -18 c9 -35 16 -66 16 -69 0 -2 -13 -9 -29 -14 -30 -11 -30 -11 -46 46
-9 31 -18 65 -21 74 -5 15 7 21 52 27 6 0 19 -28 28 -64z"
      />
      <path
        :fill="color"
        d="M14351 7637 c-34 -133 -66 -254 -71 -269 -8 -26 -6 -28 23 -36 21 -6
34 -5 38 2 3 6 28 98 55 204 27 105 51 192 54 192 3 0 36 -62 74 -137 95 -192
205 -357 264 -394 59 -38 86 -37 126 4 30 29 38 52 90 265 60 243 64 283 28
315 -19 18 -161 87 -177 87 -6 0 -21 -13 -33 -29 l-21 -29 57 -21 c31 -12 74
-33 96 -47 37 -25 38 -27 31 -70 -7 -49 -87 -352 -104 -396 -22 -59 -71 -23
-163 122 -67 104 -144 247 -194 360 -43 97 -49 105 -85 114 l-26 6 -62 -243z"
      />
      <path
        :fill="color"
        d="M2430 6688 c-206 -84 -284 -108 -372 -115 -46 -4 -78 -10 -78 -17 0
-6 -3 -22 -7 -35 l-6 -24 84 6 c46 3 124 18 173 32 49 14 92 22 96 18 4 -4 24
-50 44 -102 39 -99 38 -111 -9 -111 -16 0 -27 17 -51 78 -27 68 -33 77 -54 74
-13 -1 -26 -4 -28 -7 -3 -2 9 -38 26 -80 26 -65 28 -75 14 -75 -33 0 -118 48
-170 95 l-52 47 -20 -23 c-11 -13 -19 -27 -20 -31 -1 -28 186 -148 232 -148
43 0 47 -9 22 -53 -30 -55 -54 -156 -54 -234 0 -55 2 -63 19 -63 11 0 26 -2
34 -6 12 -4 15 12 19 88 5 89 33 193 52 193 5 0 20 -30 35 -67 14 -36 29 -69
32 -73 3 -3 27 4 53 15 62 26 65 26 77 -10 11 -30 31 -38 57 -22 10 7 9 16 -2
44 l-15 36 47 17 c26 10 51 21 55 25 4 4 -8 45 -28 91 -36 85 -38 109 -10 109
18 0 18 2 3 35 -9 20 -18 25 -34 22 -21 -4 -27 6 -61 88 -38 92 -38 92 -66 83
-15 -6 -27 -13 -25 -17 47 -109 69 -174 62 -181 -5 -4 -18 -10 -28 -12 -16 -2
-27 15 -62 102 -23 58 -39 108 -36 111 4 3 39 18 77 34 39 15 75 29 81 32 7 2
54 -102 120 -266 59 -149 113 -271 119 -271 6 0 19 6 29 13 17 12 14 22 -37
149 -54 134 -54 135 -36 159 23 30 23 38 -1 69 -19 25 -19 25 -34 5 -14 -20
-15 -20 -24 5 -17 44 -93 224 -95 226 -1 0 -67 -26 -147 -58z m139 -427 c22
-56 21 -64 -15 -75 -18 -6 -24 1 -43 50 -26 69 -26 73 2 83 27 11 28 9 56 -58z
m-114 -36 c16 -36 26 -67 24 -68 -2 -2 -16 -8 -30 -14 -26 -11 -27 -10 -53 50
-14 34 -26 66 -26 70 0 7 35 25 51 26 4 1 19 -28 34 -64z"
      />
      <path
        :fill="color"
        d="M15287 6403 c-64 -153 -117 -283 -117 -289 0 -6 77 -44 171 -84 188
-80 296 -144 351 -209 37 -44 61 -48 87 -17 22 27 -79 128 -191 189 -55 31
-67 48 -50 74 9 14 230 -77 249 -103 7 -9 22 -14 39 -12 26 3 30 9 41 58 6 30
15 82 18 116 7 61 7 61 -21 68 -34 9 -40 0 -48 -77 -3 -33 -8 -63 -11 -65 -2
-3 -56 17 -119 43 -90 38 -113 52 -108 64 3 9 41 97 84 196 l77 180 -29 14
c-17 8 -32 13 -34 10 -2 -2 -50 -112 -105 -244 -56 -132 -106 -244 -110 -248
-9 -9 -71 18 -71 30 0 4 41 103 91 220 51 120 88 218 83 223 -5 4 -19 11 -30
14 -19 6 -29 -12 -114 -211 -51 -120 -94 -220 -96 -222 -6 -6 -64 21 -64 31 0
5 46 115 101 246 56 130 103 242 106 248 2 6 -4 14 -14 17 -10 2 -25 8 -33 11
-12 5 -40 -54 -133 -271z"
      />
      <path
        :fill="color"
        d="M15765 6473 l-31 -15 20 -79 c10 -43 17 -82 14 -84 -3 -3 -28 -8 -57
-12 -50 -6 -51 -6 -51 -39 0 -39 8 -41 106 -23 77 14 169 58 227 109 52 46 55
55 31 89 l-16 23 -37 -35 c-42 -40 -111 -87 -127 -87 -6 0 -15 21 -18 48 -4
26 -13 63 -19 83 -12 37 -12 37 -42 22z"
      />
      <path
        :fill="color"
        d="M1220 6209 c-91 -37 -169 -70 -173 -71 -5 -2 14 -61 43 -132 28 -71
50 -130 48 -131 -2 -2 -39 -18 -83 -35 -44 -17 -81 -33 -83 -35 -2 -2 12 -41
23 -62 1 -2 39 13 86 31 46 19 87 31 90 28 3 -4 28 -62 54 -128 l47 -121 172
69 c94 38 178 73 187 76 15 6 11 22 -32 127 -26 66 -48 125 -49 131 0 5 23 18
50 28 28 10 50 19 50 21 0 7 -22 65 -25 65 -2 0 -24 -9 -50 -20 -26 -11 -50
-18 -55 -15 -4 3 -30 59 -56 125 -34 85 -52 120 -63 119 -9 -1 -90 -32 -181
-70z m201 -116 l37 -91 -45 -17 c-25 -10 -48 -13 -52 -9 -12 14 -74 174 -69
179 9 10 74 34 83 31 5 -1 26 -43 46 -93z m-163 -40 c17 -43 34 -86 38 -95 5
-14 -4 -22 -41 -38 -26 -11 -49 -19 -50 -18 -6 6 -75 177 -75 185 0 7 70 39
91 42 3 1 19 -34 37 -76z m266 -214 c20 -50 36 -92 34 -94 -9 -6 -91 -35 -93
-33 -6 6 -75 182 -72 183 14 12 66 34 78 35 12 0 28 -27 53 -91z m-157 -55
c18 -43 32 -84 33 -91 0 -11 -87 -50 -94 -42 -6 6 -76 182 -73 184 13 9 84 33
92 31 5 -1 24 -38 42 -82z"
      />
      <path
        :fill="color"
        d="M3895 6372 c-72 -42 -147 -87 -167 -99 l-37 -22 69 -117 c38 -65 67
-121 64 -125 -2 -5 -38 -27 -79 -50 l-74 -42 15 -29 c8 -15 19 -28 23 -28 5 0
43 20 85 44 l75 45 62 -107 c34 -59 66 -112 71 -119 7 -9 31 1 91 36 45 27
123 73 174 103 l91 53 -65 110 c-36 61 -67 115 -69 120 -3 6 18 24 45 39 53
31 52 30 15 85 -2 2 -24 -8 -50 -23 -25 -14 -50 -24 -54 -21 -5 3 -37 55 -72
115 -34 60 -67 110 -73 110 -5 -1 -69 -35 -140 -78z m179 -102 c26 -44 44 -85
41 -91 -4 -5 -23 -18 -43 -28 l-37 -19 -52 88 -52 89 42 24 c23 14 45 23 48
21 3 -2 27 -40 53 -84z m-144 -86 c29 -47 50 -86 49 -88 -20 -14 -78 -46 -86
-46 -9 0 -103 154 -103 169 0 7 69 50 82 51 4 0 30 -39 58 -86z m284 -152 c25
-43 46 -81 46 -84 0 -7 -68 -48 -80 -48 -9 0 -100 151 -100 166 0 11 72 54 82
48 3 -2 27 -39 52 -82z m-142 -88 c25 -43 44 -82 41 -87 -5 -9 -84 -50 -87
-45 -15 21 -96 161 -96 166 0 11 73 52 85 48 6 -1 31 -38 57 -82z"
      />
      <path
        :fill="color"
        d="M13822 6348 c-84 -149 -152 -271 -150 -272 2 -2 62 -36 133 -76 216
-122 318 -201 376 -289 13 -21 19 -23 44 -14 16 5 30 14 32 20 7 20 -87 129
-161 187 -64 50 -74 62 -65 77 5 11 14 19 19 19 15 0 204 -112 220 -130 8 -10
27 -20 42 -24 27 -6 28 -4 52 76 14 46 28 100 31 120 7 34 5 38 -20 44 -33 8
-38 1 -54 -72 -7 -29 -17 -56 -22 -59 -6 -5 -185 86 -217 110 -1 1 45 85 102
186 l105 184 -21 18 c-12 10 -26 16 -31 14 -8 -2 -256 -426 -269 -461 -5 -10
-36 -1 -61 18 -16 13 -9 29 102 225 l120 211 -29 15 -29 15 -39 -67 c-22 -38
-72 -126 -112 -198 -94 -167 -86 -158 -121 -139 -16 8 -29 17 -29 21 0 4 56
106 124 227 69 122 128 229 131 238 5 12 -2 21 -22 31 l-28 15 -153 -270z"
      />
      <path
        :fill="color"
        d="M14304 6370 c-21 -8 -22 -13 -17 -94 l6 -86 -57 0 -56 0 0 -35 0 -35
63 0 c108 0 217 37 299 102 37 29 37 30 23 59 -9 16 -18 29 -21 29 -4 0 -20
-11 -36 -26 -32 -26 -120 -74 -138 -74 -5 0 -10 19 -11 43 0 60 -12 120 -24
123 -6 1 -20 -1 -31 -6z"
      />
      <path
        :fill="color"
        d="M16477 6122 c-10 -16 -217 -505 -215 -507 17 -8 61 -25 63 -23 1 2
29 68 62 148 34 80 71 168 83 195 l22 50 52 -155 c58 -172 123 -324 164 -385
58 -84 127 -104 180 -51 34 34 194 419 199 481 4 46 2 52 -29 82 -18 17 -60
48 -92 67 l-60 36 -27 -26 -28 -27 57 -34 c70 -42 112 -81 112 -104 0 -18 -77
-210 -136 -339 -37 -81 -53 -97 -83 -81 -45 25 -160 300 -241 578 -17 60 -26
76 -50 88 -16 8 -31 12 -33 7z"
      />
      <path
        :fill="color"
        d="M4918 5227 l-66 -72 -29 28 c-35 33 -40 33 -63 5 -18 -23 -18 -23 11
-53 l29 -31 -98 -96 -97 -97 -44 19 c-24 11 -46 20 -50 20 -12 0 -33 -52 -24
-60 4 -4 59 -27 121 -50 109 -42 113 -43 132 -25 30 27 25 42 -19 57 l-39 13
84 89 85 89 33 -32 34 -33 18 26 c17 26 16 27 -12 57 l-28 29 72 73 73 73 -24
22 c-13 12 -25 22 -28 21 -2 0 -34 -33 -71 -72z"
      />
      <path
        :fill="color"
        d="M4895 4934 l-148 -155 59 -60 58 -59 -57 -58 -57 -58 25 -24 25 -24
58 57 58 57 59 -60 c45 -46 62 -57 72 -48 7 6 77 78 155 160 l141 149 -58 59
-59 60 37 38 37 38 -25 24 -25 24 -38 -37 -37 -36 -62 54 c-34 30 -63 55 -66
55 -2 0 -71 -70 -152 -156z m200 26 l29 -30 -42 -42 -42 -42 -35 34 -35 34 37
38 c20 21 42 38 48 38 6 0 24 -14 40 -30z m108 -192 l-43 -42 -30 29 c-16 16
-30 33 -30 39 0 6 17 27 37 48 l37 38 36 -35 35 -35 -42 -42z m-241 65 c15
-15 28 -32 28 -38 0 -6 -17 -28 -38 -48 l-38 -37 -33 34 -34 35 32 40 c18 23
38 41 44 41 6 0 24 -12 39 -27z m120 -120 c15 -15 28 -32 28 -38 0 -6 -17 -28
-38 -48 l-38 -37 -33 34 -33 34 33 41 c18 23 37 41 43 41 5 0 23 -12 38 -27z"
      />
      <path
        :fill="color"
        d="M13067 5302 l-97 -98 93 -92 c52 -51 98 -92 103 -92 20 1 55 30 133
113 83 86 84 88 66 107 -19 21 -19 20 -100 -60 -44 -44 -85 -80 -91 -80 -7 0
-17 7 -24 16 -12 13 -3 26 61 90 l74 74 -60 60 -60 60 -98 -98z m113 -17 c11
-14 6 -23 -35 -65 -46 -47 -50 -49 -67 -33 -18 16 -17 19 29 65 26 26 50 48
54 48 4 0 12 -7 19 -15z"
      />
      <path
        :fill="color"
        d="M13382 5107 c-46 -46 -54 -50 -72 -39 -26 16 -25 16 -45 -14 -13 -20
-14 -28 -4 -40 11 -13 0 -28 -64 -91 -66 -67 -78 -75 -92 -63 -13 11 -19 9
-40 -10 -22 -21 -23 -25 -10 -40 13 -14 10 -21 -35 -65 -28 -27 -50 -54 -50
-59 0 -5 8 -18 17 -28 16 -18 19 -17 73 37 l56 55 24 -25 24 -25 -59 -60 c-58
-58 -58 -60 -40 -80 10 -11 21 -20 25 -20 4 0 116 113 250 251 240 248 243
251 224 270 -19 19 -20 18 -78 -40 l-59 -60 -29 20 -28 21 50 56 c27 31 50 59
50 62 0 4 -8 14 -18 23 -17 15 -21 13 -70 -36z m-34 -180 l22 -23 -78 -77 -78
-78 -24 26 -24 26 74 74 c41 41 77 75 81 75 3 0 15 -10 27 -23z"
      />
      <path
        :fill="color"
        d="M12822 5047 c-50 -51 -92 -95 -92 -99 0 -3 36 -41 80 -84 44 -42 80
-83 80 -90 0 -13 30 -34 48 -34 9 0 94 110 162 208 l23 34 -22 21 c-19 19 -23
20 -31 7 -5 -8 -36 -53 -70 -99 l-62 -84 -26 27 -27 26 75 75 74 75 -54 55
c-30 30 -57 55 -60 55 -3 0 -47 -42 -98 -93z m108 -12 c11 -14 6 -23 -35 -65
-37 -38 -52 -47 -62 -38 -21 17 -16 29 29 75 47 48 50 49 68 28z"
      />
      <path
        :fill="color"
        d="M13555 4929 c-119 -59 -130 -68 -121 -103 l6 -26 73 38 c39 21 91 46
115 55 42 17 46 23 34 64 -7 21 -9 21 -107 -28z"
      />
      <path
        :fill="color"
        d="M13215 4587 c-63 -130 -61 -124 -25 -129 28 -4 34 0 57 40 25 43 73
162 73 182 0 6 -12 10 -27 10 -25 0 -33 -10 -78 -103z"
      />
      <path
        :fill="color"
        d="M3184 5014 c-76 -58 -148 -112 -158 -120 -18 -12 -15 -19 58 -113 42
-55 79 -106 82 -114 3 -9 -19 -32 -65 -67 -39 -28 -71 -55 -71 -58 1 -4 9 -17
20 -30 l19 -24 63 48 c35 26 68 51 75 56 8 6 36 -23 89 -94 42 -57 80 -107 84
-111 5 -6 270 185 322 232 4 3 -29 53 -72 111 -44 57 -80 108 -80 111 0 4 18
22 40 39 22 17 40 35 40 38 -1 4 -9 18 -20 30 l-20 24 -39 -31 c-21 -17 -43
-31 -49 -31 -6 0 -45 47 -88 105 -43 58 -81 105 -85 105 -3 0 -69 -48 -145
-106z m200 -69 c31 -41 56 -78 56 -82 0 -4 -18 -20 -39 -35 l-38 -27 -59 80
c-32 44 -59 82 -59 84 0 6 68 55 76 55 3 0 32 -34 63 -75z m-136 -95 c29 -39
55 -76 57 -83 6 -15 -74 -72 -84 -61 -14 16 -97 129 -106 143 -6 10 2 23 26
42 19 16 39 29 44 29 6 0 34 -32 63 -70z m298 -117 c27 -36 52 -72 57 -79 4
-8 -7 -24 -32 -43 l-40 -32 -61 82 c-34 44 -58 84 -54 88 25 22 68 51 73 51 4
0 29 -30 57 -67z m-127 -112 l60 -78 -39 -32 c-21 -17 -41 -31 -43 -31 -7 0
-117 148 -117 157 0 9 61 62 72 63 4 0 34 -35 67 -79z"
      />
      <path
        :fill="color"
        d="M14483 4980 c-43 -55 -78 -104 -78 -109 0 -10 172 -144 196 -154 25
-9 47 12 130 120 l76 98 -22 17 c-23 17 -24 17 -94 -72 -39 -50 -74 -90 -79
-90 -4 0 -15 7 -26 15 -17 13 -15 18 47 96 l64 83 -60 48 c-33 26 -63 48 -68
48 -4 0 -43 -45 -86 -100z m116 -4 c9 -10 2 -25 -30 -65 -44 -55 -50 -59 -68
-37 -10 12 -5 24 26 65 40 53 53 60 72 37z"
      />
      <path
        :fill="color"
        d="M14811 4820 c-41 -55 -46 -58 -62 -44 -15 14 -19 13 -38 -12 -19 -25
-20 -29 -6 -44 14 -16 10 -24 -51 -103 -60 -76 -69 -84 -86 -74 -16 10 -23 8
-39 -12 -18 -22 -18 -25 -4 -41 14 -16 12 -22 -30 -75 -42 -55 -44 -60 -28
-77 9 -10 20 -18 24 -18 4 0 27 25 51 55 23 30 48 55 54 55 19 0 47 -38 38
-52 -4 -7 -25 -34 -46 -59 -44 -53 -45 -60 -19 -83 18 -16 27 -7 228 251 115
147 213 274 217 281 7 12 -17 41 -35 42 -3 0 -28 -28 -54 -62 -27 -35 -50 -65
-52 -67 -2 -3 -15 7 -29 21 l-26 26 46 58 46 59 -23 17 c-12 10 -24 17 -27 17
-3 0 -25 -27 -49 -59z m-7 -179 c21 -23 21 -22 -53 -116 -30 -38 -56 -72 -57
-73 -4 -6 -53 32 -54 41 0 13 125 167 136 167 6 0 19 -9 28 -19z"
      />
      <path
        :fill="color"
        d="M14260 4695 c-45 -58 -81 -107 -79 -109 106 -80 159 -124 179 -147
42 -47 59 -42 102 31 21 36 54 95 73 131 33 64 33 67 16 83 -10 9 -20 16 -24
16 -3 0 -24 -35 -47 -78 -23 -42 -50 -88 -60 -102 l-19 -25 -25 24 -25 23 56
72 c31 39 60 76 64 81 8 10 -100 105 -119 105 -5 0 -46 -47 -92 -105z m119 1
c9 -10 2 -25 -30 -65 -44 -55 -50 -58 -68 -37 -9 11 -3 25 29 65 43 54 51 59
69 37z"
      />
      <path
        :fill="color"
        d="M14990 4653 c-92 -62 -100 -70 -95 -93 9 -33 13 -36 33 -22 34 23
175 111 185 115 11 3 -1 67 -13 67 -5 0 -54 -30 -110 -67z"
      />
      <path
        :fill="color"
        d="M14759 4393 c-10 -2 -22 -23 -29 -51 -6 -26 -24 -77 -39 -114 l-28
-66 33 -4 c31 -4 35 -1 53 42 26 60 51 148 51 177 0 22 -7 25 -41 16z"
      />
      <path
        :fill="color"
        d="M2418 4369 l-77 -59 -26 35 c-26 34 -27 34 -51 17 -29 -21 -29 -26
-2 -62 13 -19 18 -33 12 -39 -5 -4 -54 -42 -109 -83 l-100 -75 -45 28 -45 28
-17 -22 c-10 -12 -18 -25 -18 -28 0 -14 199 -129 222 -129 13 0 48 30 48 41 0
2 -16 13 -35 23 -19 11 -35 22 -35 25 0 4 41 37 92 75 l92 69 27 -32 c27 -32
27 -33 53 -16 14 10 26 19 26 22 0 2 -11 19 -25 37 l-25 32 80 59 c44 32 80
61 80 65 0 10 -31 50 -38 49 -4 0 -42 -27 -84 -60z"
      />
      <path
        :fill="color"
        d="M2356 4086 l-176 -134 50 -65 c28 -37 50 -68 50 -70 0 -2 -27 -23
-60 -47 -33 -24 -60 -47 -60 -51 0 -4 8 -17 19 -30 l18 -22 61 46 c33 26 62
47 64 47 2 0 26 -29 52 -65 26 -36 50 -65 53 -65 4 0 84 59 180 132 l173 131
-25 34 c-14 18 -36 48 -50 67 l-26 34 41 32 c34 27 38 34 29 51 -16 32 -35 33
-72 5 -19 -14 -37 -26 -40 -26 -4 0 -28 29 -56 65 l-49 65 -176 -134z m196 -5
l28 -39 -47 -35 -47 -35 -29 39 c-16 22 -27 42 -25 45 12 12 83 63 88 64 3 0
17 -18 32 -39z m-148 -108 l27 -38 -43 -37 c-24 -21 -45 -37 -48 -37 -3 -1
-18 18 -34 40 -27 39 -28 41 -10 54 11 7 30 22 44 34 14 11 28 20 31 21 3 0
18 -17 33 -37z m250 -27 c14 -19 26 -36 26 -39 0 -2 -21 -19 -46 -37 l-47 -33
-19 24 c-41 52 -41 55 4 88 23 17 45 31 49 31 4 0 18 -15 33 -34z m-149 -111
c15 -19 24 -38 21 -43 -3 -5 -24 -22 -47 -37 l-41 -29 -19 24 c-41 52 -41 55
4 88 23 17 45 31 49 32 4 0 19 -16 33 -35z"
      />
      <path
        :fill="color"
        d="M15336 4133 c-102 -131 -186 -241 -186 -244 0 -3 60 -53 133 -110
169 -132 259 -224 294 -300 27 -55 30 -58 58 -53 17 4 33 9 37 13 15 14 -56
133 -123 205 -62 66 -69 78 -59 96 6 12 16 18 23 13 35 -20 178 -137 194 -158
10 -13 29 -27 43 -30 29 -7 34 2 92 140 27 65 28 71 11 82 -25 19 -42 16 -52
-9 -5 -13 -18 -44 -30 -71 l-20 -47 -98 76 c-54 42 -97 81 -95 85 1 5 59 82
128 170 121 155 125 162 108 180 -9 10 -22 19 -28 19 -6 0 -85 -94 -175 -210
-90 -115 -169 -210 -176 -210 -6 0 -22 11 -34 24 l-23 24 147 187 147 187 -24
24 -24 24 -148 -190 c-82 -104 -150 -190 -152 -190 -11 0 -54 33 -54 41 0 5
74 104 165 220 158 202 165 212 149 230 -9 11 -23 19 -30 19 -7 0 -96 -107
-198 -237z"
      />
      <path
        :fill="color"
        d="M15814 4083 c-19 -4 -22 -12 -26 -84 -3 -43 -8 -82 -12 -86 -3 -4
-29 -2 -56 3 l-50 11 -9 -31 c-10 -41 1 -47 97 -53 89 -6 166 7 237 42 77 36
77 37 64 73 -6 18 -12 32 -14 32 -1 0 -22 -11 -46 -24 -24 -13 -67 -31 -96
-39 l-52 -16 6 90 c6 95 8 92 -43 82z"
      />
      <path
        :fill="color"
        d="M5985 4301 l-15 -29 118 -68 c64 -36 119 -68 121 -70 2 -1 -11 -28
-29 -58 l-31 -56 -42 24 c-23 14 -82 48 -132 75 l-90 51 -18 -22 c-10 -11 -16
-26 -14 -32 2 -6 47 -35 100 -65 53 -30 97 -58 97 -63 0 -23 -162 -73 -272
-84 -60 -6 -68 -9 -68 -28 0 -11 4 -27 9 -35 19 -29 222 9 324 61 22 11 40 18
42 16 3 -3 -28 -61 -116 -215 l-30 -52 32 -16 c37 -20 25 -33 117 130 59 106
67 116 70 90 7 -82 37 -197 69 -266 l35 -78 32 13 c17 7 31 17 30 22 0 5 -15
39 -32 77 -39 81 -62 166 -62 224 0 24 2 43 4 43 3 0 47 -25 100 -55 52 -30
100 -55 105 -55 6 0 17 12 25 27 l14 27 -129 74 c-71 40 -129 77 -129 81 0 18
52 101 63 100 7 0 62 -29 122 -64 l110 -63 17 21 c10 12 16 27 15 32 -3 8
-201 127 -231 138 -4 1 1 18 13 37 27 45 27 47 -8 65 -29 15 -30 14 -51 -20
-12 -19 -25 -35 -28 -35 -4 0 -47 23 -97 51 -157 88 -142 84 -160 50z"
      />
      <path
        :fill="color"
        d="M11795 4274 c-126 -75 -232 -137 -234 -140 -4 -3 265 -464 302 -517
35 -51 62 -53 141 -11 125 65 340 197 369 225 35 35 36 82 1 158 -23 54 -27
57 -55 53 -16 -2 -31 -8 -34 -12 -3 -5 6 -32 20 -62 14 -29 25 -61 25 -71 0
-20 -65 -65 -258 -174 -105 -60 -135 -73 -146 -64 -8 7 -33 44 -57 84 -23 40
-50 86 -60 103 l-19 32 192 112 c106 62 201 118 210 125 15 10 8 25 -65 150
-45 76 -86 140 -92 142 -5 1 -113 -58 -240 -133z m270 -44 c26 -45 46 -82 44
-84 -7 -6 -351 -206 -354 -206 -1 0 -24 37 -49 81 -32 54 -44 85 -38 91 17 17
326 197 339 198 6 0 32 -36 58 -80z"
      />
      <path
        :fill="color"
        d="M4583 3765 c-32 -41 -63 -75 -69 -75 -6 0 -19 9 -29 20 -24 26 -39
25 -59 -4 -15 -24 -15 -26 15 -47 18 -13 28 -27 25 -36 -3 -7 -40 -58 -82
-112 l-77 -98 -45 13 c-25 8 -48 14 -52 14 -6 0 -30 -44 -30 -55 0 -6 121 -42
190 -57 60 -12 63 -12 81 11 27 33 24 38 -21 46 -22 4 -40 10 -40 15 0 4 32
49 71 99 l71 91 30 -25 c36 -31 39 -31 61 0 17 24 17 25 -13 46 -16 13 -30 27
-30 32 0 4 27 43 60 85 l60 77 -23 17 c-12 10 -25 18 -29 18 -4 0 -33 -34 -65
-75z"
      />
      <path
        :fill="color"
        d="M4591 3470 c-74 -94 -132 -173 -130 -175 2 -2 32 -25 66 -53 l62 -49
-49 -63 -48 -63 25 -21 26 -20 26 30 c14 16 37 44 51 61 l25 32 64 -49 c36
-28 67 -50 70 -50 7 1 266 333 266 341 0 5 -81 73 -124 105 -2 2 11 22 30 45
l32 41 -24 19 c-32 25 -32 24 -63 -16 -15 -19 -31 -35 -35 -35 -5 0 -35 20
-67 45 -31 25 -60 45 -64 45 -4 0 -66 -77 -139 -170z m196 -26 c-18 -24 -36
-43 -42 -43 -5 0 -25 12 -43 28 l-32 28 35 46 36 47 39 -31 39 -31 -32 -44z
m132 -34 l34 -29 -34 -43 c-18 -24 -34 -45 -35 -46 -4 -6 -74 52 -74 62 0 11
60 86 68 86 4 -1 22 -14 41 -30z m-250 -39 c38 -31 38 -30 -17 -100 l-19 -24
-37 28 c-20 15 -36 31 -36 34 0 10 63 91 70 91 3 0 20 -13 39 -29z m138 -176
c-17 -24 -37 -44 -42 -45 -6 0 -26 12 -44 28 l-33 27 37 48 36 48 39 -31 40
-31 -33 -44z"
      />
      <path
        :fill="color"
        d="M13093 3590 l-223 -168 176 -233 c97 -129 185 -244 197 -256 43 -48
69 -35 319 154 76 58 147 116 159 131 27 35 21 87 -18 151 -26 40 -33 46 -62
44 -18 0 -35 -4 -38 -7 -3 -3 6 -24 21 -46 41 -62 47 -84 29 -109 -21 -31
-332 -261 -352 -261 -15 1 -162 185 -162 203 0 5 84 72 188 149 103 78 190
142 192 144 3 2 -178 245 -198 265 -3 4 -106 -69 -228 -161z m263 -2 c26 -35
51 -68 56 -75 7 -8 -40 -48 -151 -132 -88 -67 -164 -121 -169 -121 -5 0 -35
33 -65 74 l-56 74 157 120 c86 66 162 121 169 121 6 1 33 -27 59 -61z"
      />
      <path
        :fill="color"
        d="M7296 3764 c-18 -46 -12 -50 142 -89 81 -20 151 -41 156 -46 9 -8
-107 -481 -124 -509 -6 -9 -26 -7 -84 9 -42 12 -78 21 -80 21 -4 0 4 -72 9
-77 1 -2 37 -12 80 -23 86 -22 108 -20 130 13 7 12 44 139 81 282 37 143 68
262 70 264 2 2 67 -13 145 -33 78 -21 145 -34 149 -29 4 4 10 20 13 34 l7 26
-338 87 c-185 47 -340 86 -343 86 -4 0 -10 -7 -13 -16z"
      />
      <path
        :fill="color"
        d="M10492 3735 c-184 -52 -336 -95 -338 -98 -2 -2 1 -17 6 -34 l11 -30
152 43 c83 23 152 42 153 41 7 -12 20 -88 15 -91 -3 -2 -60 -18 -126 -36 -66
-18 -123 -36 -128 -39 -4 -4 20 -106 53 -227 85 -306 76 -285 108 -278 15 4
30 8 33 10 4 2 -18 90 -48 196 -30 106 -56 207 -60 224 l-5 31 82 23 c46 12
89 24 97 27 10 4 13 -9 13 -54 0 -78 -21 -144 -66 -210 -20 -29 -35 -55 -33
-57 47 -36 52 -36 76 -3 36 47 70 118 84 171 6 25 14 46 18 46 13 0 108 -59
166 -103 l60 -45 16 31 c16 30 16 31 -10 52 -36 31 -126 87 -188 119 -42 21
-53 31 -53 51 0 20 7 26 38 34 20 6 67 19 104 30 l67 19 15 -51 c58 -207 87
-318 82 -325 -3 -5 -33 -17 -66 -26 l-60 -17 17 -30 c21 -35 23 -35 99 -9 65
22 84 41 84 79 0 24 -114 448 -122 456 -2 3 -60 -11 -129 -30 -68 -19 -129
-35 -136 -35 -11 0 -29 77 -20 86 2 3 70 23 151 46 145 40 146 40 140 67 -4
14 -9 29 -13 32 -3 4 -156 -35 -339 -86z"
      />
      <path
        :fill="color"
        d="M8875 3488 c-22 -35 -67 -91 -99 -126 l-59 -63 26 -27 27 -26 62 67
63 67 73 0 72 0 0 -84 0 -83 -77 -7 c-42 -3 -114 -6 -160 -6 l-83 0 0 -36 0
-36 160 7 160 8 0 -157 0 -156 35 0 35 0 0 155 0 155 160 0 160 0 0 35 0 35
-160 0 -160 0 0 85 0 85 140 0 140 0 0 35 0 35 -225 0 -225 0 20 33 c11 17 20
35 20 39 0 4 -55 29 -64 28 -1 0 -19 -28 -41 -62z"
      />
      <path
        :fill="color"
        d="M3796 2845 c-9 -13 -16 -26 -16 -29 0 -3 47 -41 105 -86 58 -45 105
-84 105 -88 0 -4 -18 -27 -39 -52 l-39 -45 -58 46 c-33 25 -87 67 -121 94
l-63 48 -19 -24 c-11 -13 -20 -26 -21 -29 0 -3 43 -39 96 -79 76 -59 92 -76
80 -83 -38 -21 -183 -40 -264 -35 l-83 6 3 -37 3 -37 90 -3 c87 -3 227 18 267
39 10 5 18 7 18 4 0 -4 -40 -58 -90 -122 -49 -63 -90 -119 -90 -123 0 -9 40
-40 51 -40 3 0 46 52 95 116 l89 115 6 -118 c8 -148 38 -253 72 -253 47 0 50
11 22 106 -24 83 -38 245 -22 261 3 3 47 -27 98 -66 50 -39 95 -71 99 -71 13
0 43 52 33 59 -45 30 -223 174 -223 180 0 5 16 29 36 55 l36 47 41 -33 c23
-19 73 -58 111 -88 l68 -54 19 25 c10 13 19 27 19 30 0 3 -45 40 -99 83 -55
42 -103 81 -106 86 -3 5 5 25 19 43 l26 33 -29 22 -29 21 -29 -34 -28 -35
-109 85 c-59 47 -109 85 -111 85 -1 0 -10 -11 -19 -25z"
      />
      <path
        :fill="color"
        d="M14015 2783 c-33 -26 -81 -63 -106 -83 l-47 -36 77 -100 c48 -62 85
-100 98 -102 27 -4 234 146 230 167 -1 8 -9 18 -18 24 -13 8 -33 -3 -95 -50
-105 -79 -103 -78 -119 -57 -8 11 -15 22 -15 25 0 4 35 33 78 64 42 32 79 59
81 61 4 4 -91 134 -98 134 -3 -1 -33 -22 -66 -47z m67 -85 c-6 -8 -31 -28 -55
-46 -42 -30 -45 -31 -61 -14 -15 17 -12 21 41 60 50 37 59 40 72 28 11 -11 11
-18 3 -28z"
      />
      <path
        :fill="color"
        d="M13700 2543 c-47 -36 -93 -71 -103 -78 -18 -12 -14 -19 52 -107 39
-52 71 -99 71 -105 0 -5 9 -18 20 -28 21 -19 22 -18 130 91 l109 109 -18 24
-18 23 -84 -85 -84 -86 -23 29 -22 28 85 63 c47 35 81 67 78 73 -24 40 -87
116 -97 115 -6 0 -49 -30 -96 -66z m99 -37 c10 -12 3 -22 -39 -55 -29 -23 -55
-41 -60 -41 -10 0 -34 29 -29 34 21 21 96 75 105 75 6 1 17 -5 23 -13z"
      />
      <path
        :fill="color"
        d="M14274 2528 c-82 -62 -83 -63 -99 -42 -13 18 -14 18 -39 -5 -20 -19
-23 -28 -15 -42 8 -16 -4 -28 -78 -84 -79 -60 -89 -64 -100 -49 -11 16 -14 16
-38 0 -26 -17 -31 -31 -15 -41 18 -11 11 -21 -50 -65 -49 -36 -58 -46 -50 -61
18 -33 29 -31 89 15 l60 46 21 -29 21 -30 -65 -48 c-36 -26 -65 -52 -66 -57 0
-5 7 -17 16 -27 15 -17 32 -6 295 192 153 115 279 213 279 217 0 4 -7 15 -15
26 -14 18 -17 16 -82 -32 -70 -52 -81 -53 -103 -11 -8 14 1 25 48 60 31 23 59
44 61 45 2 2 -5 14 -16 27 l-19 25 -40 -30z m-80 -183 c9 -13 16 -26 16 -28 0
-6 -148 -117 -163 -123 -15 -5 -51 30 -46 45 4 11 160 130 170 131 4 0 14 -11
23 -25z"
      />
      <path
        :fill="color"
        d="M14400 2311 c-127 -42 -140 -49 -140 -83 0 -15 2 -28 4 -28 2 0 51
16 109 35 57 19 112 35 121 35 12 0 16 9 16 35 0 42 0 42 -110 6z"
      />
      <path
        :fill="color"
        d="M14045 2065 c-14 -25 -46 -70 -70 -100 l-44 -53 31 -11 c26 -9 35 -8
50 6 23 21 103 149 113 181 6 19 3 22 -23 22 -25 0 -35 -8 -57 -45z"
      />
      <path
        :fill="color"
        d="M6040 2810 c-20 -38 -11 -47 114 -100 115 -48 124 -54 116 -74 -22
-55 -41 -96 -44 -96 -2 0 -66 27 -143 59 l-138 60 -13 -31 c-7 -17 -11 -32 -9
-35 3 -2 49 -23 104 -46 55 -23 102 -46 104 -52 7 -17 -162 -95 -241 -111 -41
-8 -76 -17 -78 -19 -2 -2 -1 -18 3 -35 7 -31 8 -32 51 -25 71 10 163 43 242
86 39 22 72 37 72 35 0 -3 -25 -62 -55 -132 -30 -70 -55 -133 -55 -140 0 -13
57 -37 64 -26 2 4 27 63 56 132 29 69 55 129 58 134 3 6 12 -21 19 -60 20 -99
113 -284 143 -284 4 0 18 8 30 18 l23 19 -32 47 c-44 63 -86 159 -100 225 -6
30 -10 56 -8 58 2 2 52 -17 110 -42 58 -25 108 -45 111 -45 3 0 12 14 21 30
15 29 15 31 -10 40 -66 25 -241 102 -248 109 -4 4 3 33 17 64 l24 56 127 -55
c69 -29 128 -54 130 -54 2 0 8 14 14 31 12 34 26 25 -154 102 -84 36 -85 37
-70 98 5 20 2 27 -20 37 -35 16 -33 17 -51 -28 -9 -22 -17 -40 -19 -40 -1 0
-27 11 -56 24 -193 85 -198 86 -209 66z"
      />
      <path
        :fill="color"
        d="M11555 2732 c-170 -69 -312 -127 -314 -128 -4 -4 19 -64 25 -64 1 0
68 27 148 59 l145 59 15 -44 c17 -52 30 -42 -129 -104 -60 -24 -111 -44 -112
-45 -2 -1 38 -103 88 -226 50 -123 95 -234 99 -246 8 -20 13 -21 40 -12 16 6
30 15 30 20 0 5 -29 80 -64 166 -36 87 -74 181 -85 210 l-20 51 91 37 c50 20
93 33 97 30 3 -4 6 -46 6 -94 0 -78 -3 -93 -34 -155 -32 -66 -33 -70 -16 -83
11 -7 24 -13 31 -13 29 0 94 156 94 225 0 19 2 35 4 35 14 0 144 -64 191 -94
l56 -36 14 32 c12 30 12 34 -3 46 -23 19 -189 97 -235 112 -33 10 -38 16 -35
38 3 22 15 31 97 64 52 21 98 35 101 31 4 -5 37 -84 74 -177 50 -126 64 -171
56 -181 -6 -7 -33 -21 -61 -31 -27 -10 -49 -20 -49 -23 1 -4 9 -17 20 -30 l20
-23 51 18 c65 24 99 55 99 91 0 25 -153 426 -170 446 -3 4 -61 -15 -129 -43
-67 -27 -126 -50 -130 -50 -9 0 -31 53 -31 75 0 6 65 37 144 69 l144 58 -10
29 c-6 17 -17 29 -26 28 -10 0 -156 -58 -327 -127z"
      />
      <path
        :fill="color"
        d="M7727 2333 c-4 -3 -7 -18 -7 -33 l0 -27 157 -22 c87 -12 160 -24 162
-27 8 -7 -63 -506 -74 -520 -8 -10 -25 -10 -88 0 l-77 13 6 -36 c4 -20 8 -37
9 -38 5 -7 113 -23 151 -23 34 0 47 5 58 23 9 13 31 134 54 297 30 212 42 275
53 274 8 0 74 -9 147 -19 73 -10 134 -16 136 -14 2 2 7 18 10 34 l7 30 -338
48 c-362 51 -356 50 -366 40z"
      />
      <path
        :fill="color"
        d="M9686 2272 c-10 -30 -114 -193 -142 -223 l-25 -27 31 -22 c18 -13 35
-19 39 -13 5 8 90 122 97 131 6 8 139 20 146 14 3 -4 10 -43 13 -88 l7 -81
-63 -6 c-35 -3 -106 -11 -156 -18 l-93 -12 0 -34 0 -35 53 6 c28 4 100 13 160
20 125 15 109 29 127 -119 20 -173 17 -165 56 -165 19 0 34 4 34 8 0 4 -7 59
-14 122 -8 63 -16 129 -18 145 l-3 30 155 20 155 20 -3 30 c-2 17 -5 32 -7 34
-2 1 -71 -5 -154 -15 -83 -10 -152 -16 -155 -13 -2 2 -7 40 -11 85 l-7 81 38
6 c22 3 83 11 137 18 97 11 97 11 97 40 0 15 -4 30 -9 33 -4 3 -96 -6 -202
-19 -107 -14 -204 -25 -216 -25 -22 0 -22 0 -6 35 19 40 18 43 -24 51 -25 5
-32 2 -37 -14z"
      />
      <path
        :fill="color"
        d="M5563 1769 c-13 -34 -30 -24 180 -111 55 -23 101 -46 103 -53 7 -18
-193 -480 -209 -483 -8 -2 -44 10 -80 27 -36 16 -68 27 -71 23 -3 -3 -6 -20
-6 -38 0 -30 5 -35 58 -59 77 -36 132 -43 154 -19 9 11 64 133 123 272 59 138
108 252 109 252 2 0 61 -25 131 -55 71 -30 134 -55 141 -55 9 0 34 40 34 55 0
4 -637 275 -647 275 -5 0 -14 -14 -20 -31z"
      />
      <path
        :fill="color"
        d="M12020 1623 c-129 -52 -245 -99 -257 -103 -22 -9 -20 -15 87 -279
132 -328 132 -328 167 -335 42 -9 453 152 500 195 28 27 31 92 7 162 -12 37
-21 47 -37 47 -42 0 -46 -11 -29 -78 12 -46 14 -67 6 -80 -11 -17 -342 -156
-400 -168 l-31 -6 -48 121 c-27 66 -47 123 -44 125 2 2 101 43 219 91 118 48
217 89 219 91 4 4 -102 278 -117 301 -5 8 -77 -17 -242 -84z m234 -83 c20 -50
36 -92 36 -94 0 -4 -346 -143 -369 -148 -12 -3 -81 140 -81 167 0 5 85 44 188
87 103 42 188 77 188 77 1 1 18 -40 38 -89z"
      />
      <path
        :fill="color"
        d="M7680 1077 c-47 -45 -100 -94 -118 -107 l-32 -25 23 -29 23 -28 69
56 c67 54 72 56 115 50 101 -12 102 -13 96 -47 -3 -18 -8 -56 -12 -84 -4 -30
-12 -53 -18 -53 -6 0 -76 9 -155 20 -79 11 -145 19 -147 17 -2 -2 -7 -18 -10
-35 -5 -24 -3 -32 7 -32 31 -1 293 -40 298 -45 3 -3 -4 -71 -15 -151 l-20
-145 23 -5 c44 -11 49 -2 68 145 10 78 21 144 24 145 3 2 74 -6 158 -18 l151
-22 5 30 c2 17 0 34 -5 37 -5 3 -72 14 -149 24 -89 12 -143 23 -146 31 -4 12
14 154 21 161 2 2 63 -6 137 -16 73 -11 134 -19 135 -18 7 11 11 67 5 67 -24
0 -425 61 -430 65 -2 3 8 18 23 34 l28 29 -30 16 c-17 9 -32 16 -34 16 -2 0
-41 -37 -88 -83z"
      />
      <path
        :fill="color"
        d="M10005 1104 c-187 -24 -343 -43 -347 -43 -5 -1 -8 -14 -8 -30 0 -17
3 -32 8 -34 4 -2 74 4 156 14 82 10 152 17 154 14 3 -3 6 -24 6 -47 l1 -43
-132 -15 c-73 -9 -134 -18 -136 -20 -2 -3 10 -120 27 -260 l31 -255 37 -3 c36
-3 38 -2 33 25 -14 76 -54 427 -50 433 3 4 37 11 77 14 40 4 84 10 97 13 24 6
24 5 17 -48 -10 -73 -45 -148 -97 -204 l-42 -46 23 -24 c23 -24 24 -24 43 -7
38 33 107 134 118 173 7 21 15 39 19 39 13 0 64 -42 136 -113 l71 -69 22 30
21 30 -70 64 c-38 36 -92 80 -119 99 -39 26 -51 40 -51 60 0 26 2 27 88 38
122 15 129 15 135 -11 3 -13 13 -96 23 -185 14 -124 15 -166 6 -175 -6 -6 -36
-13 -67 -16 -30 -2 -55 -6 -55 -9 0 -2 7 -18 16 -34 15 -30 16 -30 72 -24 64
8 98 26 113 58 6 15 1 90 -20 250 -16 126 -31 230 -33 233 -3 2 -56 -3 -118
-11 -163 -21 -156 -23 -163 27 -3 24 -5 44 -4 45 2 1 71 11 156 22 84 10 154
21 156 23 2 2 0 17 -3 33 l-7 31 -340 -42z"
      />
    </g>
  </svg>
</template>
